import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Customer, CustomerAlert, CustomerContact, ContactPriority, SiteContact } from '../../_models/customer';
import { CreateEditSite, GetAuditScriptSite, GetAuditScriptSiteParameter, ISiteDetailsModelData, ISiteInformationModelData, PauseCameraAlarmDto, Site, SiteCameraScoreResponse, SiteDashboardCounts, SiteDto, SiteInformation } from '../../_models/Sites/site';
import { CreateOrEditNVRDto, DeviceCredentialDto, DeviceDto, DeviceNoteDto, DeviceStatistics, DeviceTagParameter, DeviceTemplate, IDeviceDtoModelData, NVRDetailDatesParameter, NVRGeneralDto, NVRPhysicalAccessDto, NVRPortDto, PagedResultDtoOfGetDeviceForView, SmtpConfigurationDto } from '../../_models/Devices/Device';
import { IncidentReportDto, IncidentResult, SiteIncidentTypeCount } from '../../_models/incident';
import { ZabbixCamera, ZabbixCount, ZabbixLastUpdateDetails, ZabbixNvr, ZabbixSiteCount } from '../../_models/zabbix';
import { GetCustomerScheduleTemplatesForEditOutput, Template } from '../../_models/Monitoring/template';
import { SearchFilter, ReportsView, SearchOverrideParameters, DynamicSearchFilter, DynamicSearchResult } from '../../_models/search-stealth/search-page-models-v2';
import { AssignOverrideDto, TimezoneList } from '../../_models/Monitoring/assign-override';
import { CreateUpdateDeviceAlarm, IDeviceAlarmModelData } from '../../_models/Devices/DeviceAlarm';
import { CreateUpdateDeviceWirelessCard, IDeviceWirelessCardModelData } from '../../_models/Devices/DeviceWirelessCard';
import { CreateUpdateDeviceInput, IDeviceInputModelData } from '../../_models/Devices/DeviceInput';
import { CamerasCredential, BulkCamerasCredentialRequest, CreateUpdateDeviceCamera, DeviceCamera, IDeviceCameraModelData, BulkCamerasDetailRequest, BulkCamerasGeneralInfoRequest } from '../../_models/Devices/DeviceCamera';
import { CreateUpdateDeviceNic, IDeviceNicModelData } from '../../_models/Devices/DeviceNic';
import { CreateUpdateDeviceModule, IDeviceModuleModelData } from '../../_models/Devices/DeviceModule';
import { CreateUpdateDeviceOutput, DeviceOutput, IDeviceOutputModelData } from '../../_models/Devices/DeviceOutput';
import { CreateUpdateDeviceAPIService, IDeviceApiServiceModelData, IOrchidApiServiceModelData } from '../../_models/Devices/DeviceAPIService';
import { CredentialType, DeviceType, OutputType } from 'src/app/_stealth/shared/Enum/lookups';
import { VendorServicesScheduleDto } from '../../_models/Sites/SiteVendor';
import { WorkerScheduleDto } from '../../_models/Sites/SiteWorker';
import { SiteAuthority, SiteAuthorityNote, SiteAuthorityPhonePriorityDto, SiteAuthorityPriorityDto } from '../../_models/Sites/SiteAuthority';
import { CountryListDto, ISiteAddressModelData, SiteAddressCoordinateDto, StateListDto } from '../../_models/Sites/SiteAddress';
import { ISiteAdditionalInfoModelData, SiteAdditionalInfo } from '../../_models/Sites/SiteAdditionalInfo';
import { SiteServiceDetails, SiteServiceMedia } from '../../_models/Sites/SiteService';
import { SiteAlertDto } from '../../_models/Sites/SiteAlert';
import { SiteEmergencyContactEmailDetailsDto, SiteEmergencyEmailTemplateDto } from '../../_models/Sites/SiteEmergencyContact';
import { IncidentVideoStatus, SiteIncidentEmailDetailsDto } from '../../_models/Sites/SiteIncident';
import { AttackMapsDto, IAttackMapTreeModelData, IAttackMapsDtoModelData, ISiteMapsDtoModelData, SiteMapsDto } from '../../_models/Sites/SiteMap';
import { ISiteAttachmentModelData, SiteAttachmentsDto } from '../../_models/Sites/SiteAttachment';
import { TransferInputDto } from '../../_models/Sites/SiteTransfer';
import { Authority, AuthorityNote, AuthorityResult } from '../../_models/Authorities/Authorities';
import { OnboardDevicesNewDto, PausedDevicesDto } from '../../_models/Sites/SiteDevices';
import { ISiteMonitoringHoursModelData } from '../../_models/Sites/SiteMonitoring';
import { BulkProtocolStepContactUpdateResultDto, BulkSiteProtocolUpdateDto, ISiteProtocolModelData, SiteProtocolDto, SiteProtocolParameter, SiteProtocolTableDto, emptyBulkProtocolStepContactUpdateResultDto } from '../../_models/Sites/SiteProtocol';
import { ICalendarScheduleModelData, ScheduleExceptionDto, UpdateGroupScheduleExceptionDto } from '../../_models/Monitoring/Schedules';
import { ISiteNoteResults, SiteNote } from '../../_models/Sites/SiteNote';
import { CustomerNote, ICustomerNoteModelData } from '../../_models/Customers/CustomerNotes';
import { Application, ApplicationBuild } from '../../_models/ApplicationCatalog/Application';
import { DeviceAutoRequest, DeviceCurrentVersion, DeviceToUninstall, IDeviceCurrentVersionModelData, IDeviceCurrentVersionModelDataV2 } from '../../_models/ApplicationCatalog/Device';
import { SiteTag } from '../../_models/Sites/SiteTag';
import { StealthContact, StealthContactPriority } from 'src/app/pages/shared/core/Model/Contacts/stealth-contact';
import { ServiceMedia } from '../../_models/Sites/ServiceMedia';
import { ProblemCode, ServiceTicketBulkResponse, ServiceTicketQueryDto, ServiceTicketRequestDto, ServiceTicketResponseDto } from '../../_models/Sites/ServiceTicket';
import { GuardTour, CreateEditGuardTour } from '../../_models/Monitoring/GuardTourData';
import { AIServerDetails } from '../../_models/Devices/Camera';
import { AuditReportRequestDto, AuditReportResponseDto, AuditRequestDto, AuditResponseDto } from '../../_models/CameraAudit/AuditReport';
import { BulkInstallVersionDto, PagedResultDtoOfBulkInstallVersionDto } from '../../_models/ApplicationCatalog/DeviceBulk';
import { BulkUpdateDto, ParameterBulkUpdateDto } from '../../_models/ApplicationCatalog/DeviceBulkV2';
import { Camlinks, CamlinksParameter } from '../../_models/Camlinks/Camlinks';
import { DeleteOverrideDto } from '../../_models/Monitoring/Overrides';
import { NFZParameter, NoFlyZoneScheduleGroupDto } from '../../_models/noFlyZone';
import { Partner } from '../../_models/Sites/Partner';
import { BulkSiteUpdateRequest, BulkUpdateApiResponse, BulkUpdateResult } from '../../_models/search-stealth/bulk-update-sites';

const API_BASE_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class MainHTTPService {
  constructor(private http: HttpClient) { }

  //#region Authorities
  /**
   * This is the get function for getting all authorities
   * @param advancedFilters filter for retrieving authorities
   * @returns returns all authorities
   */
  getAuthorities(
    advancedFilters?: string | null | undefined
  ): Observable<SiteAuthority[]> {
    let url = API_BASE_URL + 'api/authorities';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve authorities');
        }

        return response.result;
      })
    );
  }

  getAuthoritiesV2(
    advancedFilters?: string | null | undefined
  ): Observable<AuthorityResult> {
    let url = API_BASE_URL + 'api/v2/authorities';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve authorities');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting authority notes
   * @param authorityId The authority ID parameter
   * @returns returns all authority notes
   */
  getAuthorityNotes(authorityId: number): Observable<SiteAuthorityNote[]> {
    let url =
      API_BASE_URL +
      'api/authorities/' +
      encodeURIComponent(authorityId) +
      '/notes';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve authority notes');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the function for creating a new authority and assigning it to a site
   * @param siteId The site ID to assign the authority
   * @param authority The authority to be assigned or created
   * @returns success
   */
  createAndAssignNewAuthorityToSite(
    siteId: number,
    authority: Authority
  ): Observable<void> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent(siteId) + '/authorities';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, authority);
  }

  /**
   * This is the function for creating or editing authority notes
   * @param authorityId The authority id of the note being modified
   * @param notes The created or edited authority notes
   * @returns success
   */
  createOrEditAuthorityNotes(
    authorityId: number,
    notes: AuthorityNote[]
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/authorities/' +
      encodeURIComponent(authorityId) +
      '/notes';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, notes);
  }

  /**
   * This is the function for creating or editing an authority
   * @param input The authority being created or edited
   * @returns success
   */
  createOrEditAuthority(input: Authority | null | undefined): Observable<void> {
    let url = API_BASE_URL + 'api/authorities/';
    if (input?.id) {
      url += input.id;
      url = url.replace(/[?&]$/, '');
      return this.http.put<void>(url, input);
    }

    url = url.replace(/[?&]$/, '');
    return this.http.post<void>(url, input);
  }
  //#endregion Authorities

  //#region Configurations
  //#region SCHEDULES
  /**
   * This is the get function for getting the customer calendar schedules
   * @param customerId This is the customerId parameter
   * @returns returns the customer calendar schedules
   */
  getCalendarSchedules(
    customerId?: number | undefined,
    siteId?: number | undefined,
    nvrId?: number | undefined
  ): Observable<ICalendarScheduleModelData> {
    let url =
      API_BASE_URL + 'api/v1/Configurations/Schedules/CalendarSchedules/';
    if (nvrId !== undefined) {
      url += 'NVR/' + encodeURIComponent('' + nvrId);
    } else if (siteId !== undefined) {
      url += 'Site/' + encodeURIComponent('' + siteId);
    } else if (customerId !== undefined) {
      url += 'Customer/' + encodeURIComponent('' + customerId);
    }

    return this.http.get<ICalendarScheduleModelData>(url);
  }

  /**
   * This is the get function for getting the customer calendar schedules
   * @param customerId This is the customerId parameter
   * @returns returns the customer calendar schedules
   */
  getCustomerCalendarSchedules(
    customerId: number
  ): Observable<ICalendarScheduleModelData> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/CalendarSchedules/Customer/' +
      customerId?.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<ICalendarScheduleModelData>(url);
  }

  /**
   * This is the get function for getting the site calendar schedules
   * @param siteId This is the siteId parameter
   * @returns returns the site calendar schedules
   */
  getSiteCalendarSchedules(
    siteId: number
  ): Observable<ICalendarScheduleModelData> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/CalendarSchedules/Site/' +
      siteId?.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<ICalendarScheduleModelData>(url);
  }

  /**
   * This is the get function for getting the site calendar schedules
   * @param siteId This is the siteId parameter
   * @returns returns the site calendar schedules
   */
  getSiteGuardTourCalendarSchedules(
    siteId: number
  ): Observable<ICalendarScheduleModelData> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/GuardTourCalendarSchedules/Site/' +
      siteId?.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<ICalendarScheduleModelData>(url);
  }

  /**
   * This is the get function for getting the nvr calendar schedules
   * @param nvrId This is the nvrId parameter
   * @returns returns the nvr calendar schedules
   */
  getNVRCalendarSchedules(
    nvrId: number
  ): Observable<ICalendarScheduleModelData> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/CalendarSchedules/NVR/' +
      nvrId?.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<ICalendarScheduleModelData>(url);
  }

  /**
   * This is the function to create or edit a schedule override from the calendar
   * @param input The parameters needed to create or edit a schedule override
   * @param isUpdate
   * @returns
   */
  createOrEditExceptions(
    input: ScheduleExceptionDto[],
    isUpdate?: boolean
  ): Observable<void> {
    let url = API_BASE_URL + 'api/v1/Configurations/Schedules/Exceptions';
    if (isUpdate === true) {
      return this.http.put<any>(url, input);
    } else {
      return this.http.post<any>(url, input);
    }
  }

  /**
   * This is the function to delete a schedule override from the calendar
   * @param input The parameters needed to delete a schedule override
   * @returns
   */
  deleteExceptions(input: ScheduleExceptionDto[]): Observable<void> {
    let url =
      API_BASE_URL + 'api/v1/Configurations/Schedules/Exceptions/Delete';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, input);
  }

  deleteOverride(input: DeleteOverrideDto): Observable<void> {
    let url =
      API_BASE_URL + 'api/v3/Configurations/Schedules/GroupScheduleException';
    url = url.replace(/[?&]$/, '');

    const options = {
      body: input,
    };

    return this.http.delete<void>(url, options);
  }

  updateOverride(input: UpdateGroupScheduleExceptionDto): Observable<void> {
    let url =
      API_BASE_URL + 'api/v3/Configurations/Schedules/GroupScheduleException';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input);
  }

  getOverrides(input: SearchOverrideParameters, hasFilters: boolean = false): Observable<any> {
    let url = API_BASE_URL + 'api/v3/Configurations/Schedules/SearchOverrides';
    if (hasFilters) {
      url += '?withDetails=true';
    }
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        return response?.result;
      })
    );
  }

  getOverrideDetails(input: SearchOverrideParameters): Observable<any> {
    let url =
      API_BASE_URL + 'api/v3/Configurations/Schedules/SearchOverrideDetails';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        return response?.result;
      })
    );
  }

  getOverridesWithDetails(input: SearchOverrideParameters): Observable<any> {
    let url =
      API_BASE_URL +
      'api/v3/Configurations/Schedules/SearchOverrides?withDetails=true';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        return response?.result;
      })
    );
  }

  //#endregion SCHEDULES
  //#endregion Configurations

  //#region Countries
  /**
   * This is the get function for getting a site countries list
   * @returns returns a site countries list
   */
  getCountriesList(): Observable<CountryListDto[]> {
    let url = API_BASE_URL + 'api/countries';
    url = url.replace(/[?&]$/, '');

    return this.http.get<CountryListDto[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve countries list');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site states
   * @param countryId This is the countryId parameter
   * @returns returns a site IncidentsLast30Days
   */
  getStatesListByCountry(
    countryId: number | undefined
  ): Observable<StateListDto[]> {
    let url =
      API_BASE_URL + 'api/countries/' + countryId?.toString() + '/states';
    url = url.replace(/[?&]$/, '');

    return this.http.get<StateListDto[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve states list by country');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the timezones in Hub by Country
   * @param countryId This is the countryId parameter
   * @returns returns the timezones in Hub by Country
   */
  getTimezonesListByCountry(countryId: number): Observable<TimezoneList[]> {
    let url =
      API_BASE_URL + 'api/countries/' + countryId.toString() + '/timezones';
    url = url.replace(/[?&]$/, '');

    return this.http.get<TimezoneList[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Timezone List');
        }

        return response.result;
      })
    );
  }
  //#endregion Countries

  //#region Customers
  /**
   * This is the get function for getting all site addresses in Hub
   * @returns returns the site addresses
   */
  getAddresses(): Observable<any> {
    let url = API_BASE_URL + 'api/customers/contacts/allSiteAddress';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  editCustomer(customer: Customer): Observable<void> {
    let url = API_BASE_URL + 'api/customers/' + encodeURIComponent(customer.id);
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, customer);
  }

  /**
   * This is the get function for get a customer in Hub
   * @param id This is the customer id parameter
   * @returns returns the customer
   */
  getCustomer(id: number): Observable<Customer> {
    let url = API_BASE_URL + 'api/customers/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customer');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all customers in Hub
   * @param advancedFilters This is the advancedFilters parameter
   * @returns returns the customers
   */
  getCustomers(
    advancedFilters?: string | null | undefined
  ): Observable<Customer[]> {
    let url = API_BASE_URL + 'api/customers';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customers');
        }

        return response.result;
      })
    );
  }

  getCustomersForDashboard(): Observable<Customer[]> {
    let url = API_BASE_URL + 'api/customers/dashboard';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customers');
        }

        return response.result;
      })
    );
  }

  getCustomerForEdit(customerId: number): Observable<Customer> {
    let url = API_BASE_URL + 'api/customers/' + encodeURIComponent(customerId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customer');
        }

        return response.result;
      })
    );
  }

  activateCustomer(customerId: number): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/activate';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, null).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to activate customer');
        }

        return response.result;
      })
    );
  }

  deactivateCustomer(customerId: number): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/deactivate';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, null).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to deactivate customer');
        }

        return response.result;
      })
    );
  }

  /* Customer Notes */
  createCustomerNote(customerId: number, note: CustomerNote): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/notes';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, note).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to create customer note');
        }

        return response.result;
      })
    );
  }

  getCustomerNotes(customerId: number): Observable<CustomerNote[]> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/notes';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customer notes');
        }

        return response.result;
      })
    );
  }

  deleteCustomerNote(customerId: number, note: CustomerNote): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/notes/delete';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, note).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to delete customer note');
        }

        return response.result;
      })
    );
  }

  /* Customer Alerts */
  createCustomerAlert(
    customerId: number,
    alert: CustomerAlert
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/alerts';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, alert);
  }

  editCustomerAlert(
    customerId: number,
    alert: CustomerAlert
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/alerts';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, alert);
  }

  getCustomerAlerts(customerId: number): Observable<CustomerAlert[]> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/alerts';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customer alerts');
        }

        return response.result;
      })
    );
  }

  deleteCustomerAlert(
    customerId: number,
    alert: CustomerAlert
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/alerts/delete';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, alert).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to delete customer alerts');
        }

        return response.result;
      })
    );
  }

  getCustomerAlertRequesterNames(customerId: number): Observable<string[]> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent(customerId) +
      '/alerts/requester/suggestions';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customer alert requester names');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for marking a customer alert as read
   * @param customerId This is the customerId parameter
   * @param noteId This is the noteId parameter
   * @returns returns success
   */
  markCustomerAlertAsRead(
    customerId: number | null | undefined,
    noteId: number | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent('' + customerId) +
      '/alerts/' +
      encodeURIComponent('' + noteId) +
      '/read';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, null).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the put function for marking a customer alert as read
   * @param customerId This is the customerId parameter
   * @param noteId This is the noteId parameter
   * @returns returns success
   */
  markCustomerAlertAsUnread(
    customerId: number | null | undefined,
    noteId: number | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/customers/' +
      encodeURIComponent('' + customerId) +
      '/alerts/' +
      encodeURIComponent('' + noteId) +
      '/unread';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, null).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  getCustomerContacts(customerId: number): Observable<CustomerContact[]> {
    let url =
      API_BASE_URL +
      'api/v2/customers/' +
      encodeURIComponent(customerId) +
      '/contacts';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve customer contacts');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for exporting the customer call tree to an Excel file
   * @param customerId This is the customerId parameter
   * @returns returns the Excel file as a Blob
   */
  exportCustomerCallTreeToExcel(customerId: number): Observable<Blob> {
    let url = API_BASE_URL + 'api/customers/exportContactCallTree?customerId=' + encodeURIComponent(customerId);
    url = url.replace(/[?&]$/, '');

    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  //#endregion Customers

  //#region DEVICES

  /**
   * This is the get function for get the device
   * @param advancedFilters This is the advancedFilters parameter
   * @returns returns the device
   */
  getDevice(
    advancedFilters?: string | null | undefined
  ): Observable<IDeviceDtoModelData> {
    let url = API_BASE_URL + 'api/devices';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<IDeviceDtoModelData>(url);
  }

  /**
   * This is the get function for get the device
   * @param parameter This is the parameter parameter
   * @returns returns the device
   */
  getDevicesByParameter(
    parameter: URLSearchParams
  ): Observable<IDeviceDtoModelData> {
    let url = API_BASE_URL + 'api/devices?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<IDeviceDtoModelData>(url);
  }

  /**
   * This is the get function for get the device parameter
   * @param parameter This is the parameter parameter
   * @returns returns the device parameter
   */
  getDeviceParamsString(parameter: string): Observable<any> {
    let url = API_BASE_URL + 'api/devices?' + parameter;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for get the device dashboard
   * @param parameter This is the parameter parameter
   * @returns returns the device dashboard
   */
  getDeviceDashboard(siteIds: number[]): Observable<any> {
    let url = API_BASE_URL + 'api/devices/dashboard';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, siteIds).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device dashboard');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device count
   * @param parameter This is the parameter parameter
   * @returns returns the device count
   */
  getDeviceCount(parameter: URLSearchParams): Observable<any> {
    let url = API_BASE_URL + 'api/devices/count?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device count parameter
   * @param parameter This is the parameter parameter
   * @returns returns the device count parameter
   */
  getDeviceCountParamsString(parameter: string): Observable<any> {
    let url = API_BASE_URL + 'api/devices/count?' + parameter;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device count parameter');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting ai server details
   * @returns returns list of ai server details
   */
  getAIServerDetails(): Observable<AIServerDetails[]> {
    let url = API_BASE_URL + 'api/v3/ai-server';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device count parameter');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device camera
   * @param parameter This is the parameter parameter
   * @returns returns the device camera
   */
  getCamera(
    parameters?: string | null | undefined
  ): Observable<DeviceCamera[]> {
    let url = API_BASE_URL + 'api/devices/camera';
    if (parameters != null) {
      url += '?' + parameters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device camera');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device camera count
   * @param parameter This is the parameter parameter
   * @returns returns the device camera count
   */
  getCameraCount(parameter: URLSearchParams): Observable<any> {
    let url = API_BASE_URL + 'api/devices/camera/count?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device camera count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device camera by id
   * @param id This is the id parameter
   * @returns returns the device camera by id
   */
  getCameraById(id: number): Observable<IDeviceCameraModelData> {
    let url = API_BASE_URL + 'api/devices/camera/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device camera by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device camera
   * @param input This is the input parameter
   * @returns returns success
   */
  createCamera(input: CreateUpdateDeviceCamera): Observable<any> {
    let url = API_BASE_URL + 'api/devices/camera';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result && response?.result !== -1) {
          return response.result;
        }

        throw Error('Failed to create camera');
      })
    );
  }

  /**
   * This is the put function for updating the device camera
   * @param input This is the input parameter
   * @returns returns success
   */
  updateCamera(input: CreateUpdateDeviceCamera): Observable<any> {
    let url = API_BASE_URL + 'api/devices/camera';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }

        throw Error('Failed to update camera');
      })
    );
  }

  /**
   * This is the put function for archiving cameras
   * @param input Accepts list of camera ids
   * @returns returns success
   */
  archiveCameras(input: Array<number>): Observable<any> {
    let url = API_BASE_URL + 'api/devices/cameras/archive-cameras';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }

        throw Error('Failed to update camera');
      })
    );
  }

  /**
   * This is the get function for the device, Discovered camera by id
   * @param id This is the id parameter
   * @returns returns the device Discovered camera by id
   */
  getDiscoveredCameraById(id: number): Observable<IDeviceCameraModelData> {
    let url = API_BASE_URL + 'api/devices/discovered/camera/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device Discovered camera by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device Discovered camera
   * @param id This is the id parameter
   * @param camera This is the camera parameter
   * @returns returns success
   */
  createDiscoveredCamera(
    id: number,
    camera: CreateUpdateDeviceCamera
  ): Observable<any> {
    let url = API_BASE_URL + 'api/devices/discovered/camera/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, camera).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device nic
   * @param parameters This is the parameters parameter
   * @returns returns the device nic
   */
  getNic(parameters?: string | null | undefined): Observable<any> {
    let url = API_BASE_URL + 'api/devices/nic';
    if (parameters != null) {
      url += '?' + parameters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device NIC');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device nic count
   * @param parameter This is the parameter parameter
   * @returns returns the device camera count
   */
  getNicCount(parameter: URLSearchParams): Observable<any> {
    let url = API_BASE_URL + 'api/devices/nic/count?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device NIC count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device nic by id
   * @param id This is the id parameter
   * @returns returns the device nic by id
   */
  getNicById(id: number): Observable<IDeviceNicModelData> {
    let url = API_BASE_URL + 'api/devices/nic/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device nic by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device nic
   * @param input This is the input parameter
   * @returns returns success
   */
  createNic(input: CreateUpdateDeviceNic): Observable<any> {
    let url = API_BASE_URL + 'api/devices/nic';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device nic
   * @param input This is the input parameter
   * @returns returns success
   */
  updateNic(input: CreateUpdateDeviceNic): Observable<any> {
    let url = API_BASE_URL + 'api/devices/nic';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device module by id
   * @param id This is the id parameter
   * @returns returns the device module by id
   */
  getModuleById(id: number): Observable<IDeviceModuleModelData> {
    let url = API_BASE_URL + 'api/devices/module/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device nic by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device module
   * @param input This is the input parameter
   * @returns returns success
   */
  createModule(input: CreateUpdateDeviceModule): Observable<any> {
    let url = API_BASE_URL + 'api/devices/module';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device module
   * @param input This is the input parameter
   * @returns returns success
   */
  updateModule(input: CreateUpdateDeviceModule): Observable<any> {
    let url = API_BASE_URL + 'api/devices/module';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device Output by id
   * @param id This is the id parameter
   * @returns returns the device Output by id
   */
  getOutputById(id: number): Observable<IDeviceOutputModelData> {
    let url = API_BASE_URL + 'api/devices/output/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device output by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device Output
   * @param input This is the input parameter
   * @returns returns success
   */
  createOutput(input: CreateUpdateDeviceOutput): Observable<any> {
    let url = API_BASE_URL + 'api/devices/output';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device Output
   * @param input This is the input parameter
   * @returns returns success
   */
  updateOutput(input: CreateUpdateDeviceOutput): Observable<any> {
    let url = API_BASE_URL + 'api/devices/output';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device api-service
   * @param parameter This is the parameter parameter
   * @returns returns the device api-service
   */
  getAPIService(parameters?: string | null | undefined): Observable<any> {
    let url = API_BASE_URL + 'api/devices/api-service';
    if (parameters != null) {
      url += '?' + parameters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device api-service');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device api-service count
   * @param parameter This is the parameter parameter
   * @returns returns the device api-service count
   */
  getAPIServiceCount(parameter: URLSearchParams): Observable<any> {
    let url =
      API_BASE_URL + 'api/devices/api-service/count?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device api-service count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device api-service by id
   * @param id This is the id parameter
   * @returns returns the device api-service by id
   */
  getAPIServiceById(id: number): Observable<IDeviceApiServiceModelData> {
    let url = API_BASE_URL + 'api/devices/api-service/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device api-service by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device api-service
   * @param input This is the input parameter
   * @returns returns success
   */
  createAPIService(input: CreateUpdateDeviceAPIService): Observable<any> {
    let url = API_BASE_URL + 'api/devices/api-service';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device api-service
   * @param input This is the input parameter
   * @returns returns success
   */
  updateAPIService(input: CreateUpdateDeviceAPIService): Observable<any> {
    let url = API_BASE_URL + 'api/devices/api-service';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the post function for creating the orchid device api-service
   * @param input This is the input parameter
   * @returns returns success
   */
  createOrchidAPIService(input: CreateUpdateDeviceAPIService): Observable<any> {
    let url = API_BASE_URL + 'api/devices/orchid-api-service';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the orchid api-service by id
   * @param id This is the id parameter
   * @returns returns the orchid api-service by id
   */
  getOrchidAPIServiceById(id: number): Observable<IOrchidApiServiceModelData> {
    let url = API_BASE_URL + 'api/devices/orchid-api-service?id=' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device api-service by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the orchid api-services by parent id
   * @param id This is the id parameter
   * @returns returns the orchid api-services by parent id
   */
  getOrchidAPIServicesByParentId(
    id: number
  ): Observable<IOrchidApiServiceModelData[]> {
    let url = API_BASE_URL + 'api/devices/orchid-api-service?parentId=' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device api-service by id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for updating the orchid device api-service
   * @param input This is the input parameter
   * @returns returns success
   */
  updateOrchidAPIService(input: CreateUpdateDeviceAPIService): Observable<any> {
    let url = API_BASE_URL + 'api/devices/orchid-api-service';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the devices in Hub
   * @param filter This is the filter parameter
   * @param advancedFilters This is the advancedFilters parameter
   * @param sorting This is the sorting parameter
   * @param skipCount This is the skipCount parameter
   * @param maxResultCount This is the maxResultCount parameter
   * @returns returns the devices in Hub
   */
  getDevices(
    filter: string | null | undefined,
    advancedFilters: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfGetDeviceForView> {
    let url = API_BASE_URL + 'api/services/app/Device/GetDevices?';
    if (filter !== undefined)
      url += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (advancedFilters !== undefined)
      url +=
        'AdvancedFilters=' + encodeURIComponent('' + advancedFilters) + '&';
    if (sorting !== undefined)
      url += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount !== undefined)
      url += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url = url.replace(/[?&]$/, '');

    return this.http.get<PagedResultDtoOfGetDeviceForView>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the get function for get the NVR's for edit in Hub
   * @param id This is the id parameter
   * @returns returns the NVR's for edit in Hub
   */
  getNVRForEdit(id: number | null | undefined): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + 'api/devices/nvr/' + encodeURIComponent('' + id);
    url = url.replace(/[?&]$/, '');

    return this.http.get<TimezoneList[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve NVR for Edit');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post/put function for creating or editing an NVR
   * @param input This is the input parameter if input.device.id is null we create else we edit
   * @returns returns the device
   */
  createOrEditNVR(
    input: CreateOrEditNVRDto | null | undefined
  ): Observable<DeviceDto> {
    let url = API_BASE_URL + 'api/devices/nvr/';

    if (input?.device?.id !== undefined) {
      url += encodeURIComponent('' + input?.device?.id);
      url = url.replace(/[?&]$/, '');

      return this.http.put<any>(url, input).pipe(
        map((response: any) => {
          if (response?.result) {
            return response.result;
          }
          return 0;
        })
      );
    } else {
      url = url.replace(/[?&]$/, '');

      return this.http.post<any>(url, input).pipe(
        map((response: any) => {
          if (response?.result) {
            return response.result;
          }
          return 0;
        })
      );
    }
  }

  /**
  * Updates the general information of an existing NVR device via a PUT request.
  * 
  * @param nvr - The NVR device data to update
  * @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
  */
  editNvrGeneralInfo(
    nvr: DeviceDto
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(nvr.id?.toString()!)}/general`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, nvr).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
 * Updates the detailed information of an existing NVR device via a PUT request.
 * 
 * @param nvr - The NVR details to be updated.
 * @param deviceID - The ID of the NVR device to update.
 * @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
 */
  editNvrDetails(
    nvr: { device: DeviceDto, nvr: NVRGeneralDto }, deviceID: number
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(deviceID.toString()!)}/details`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, nvr).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
* Updates the detailed information of an existing NVR PhysicalAccess via a PUT request.
* 
* @param nvr - The NVR details to be updated.
* @param deviceID - The ID of the NVR device to update.
* @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
*/
  editNvrPhysicalAccessDetails(
    nvr: { device: DeviceDto, physicalAccess: NVRPhysicalAccessDto | null }, deviceID: number
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(deviceID.toString()!)}/physical-access`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, nvr).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
* Updates the detailed information of an existing NVR SMTP Configuration via a PUT request.
* 
* @param smtpConfig - The SMTP details to be updated.
* @param deviceID - The ID of the NVR device to update.
* @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
*/
  editNvrSMTPConfigurationDetails(
    nvr: { device: DeviceDto, smtpConfiguration: SmtpConfigurationDto }, deviceID: number
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(deviceID.toString()!)}/smtp`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, nvr).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
 * Updates the credentials of an existing NVR device via a PUT request.
 * 
 * @param credentials - The NVR credentials to be updated.
 * @param deviceID - The ID of the NVR device to update.
 * @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
 */
  editNvrCredentials(
    credentials: { device: DeviceDto, deviceCredentials: DeviceCredentialDto[] }, deviceID: number
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(deviceID.toString()!)}/credentials`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, credentials).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
 * Updates the ports of an existing NVR device via a PUT request.
 * 
 * @param ports - The NVR ports to be updated.
 * @param deviceID - The ID of the NVR device to update.
 * @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
 */
  editNvrPorts(
    ports: { device: DeviceDto, ports: NVRPortDto[] }, deviceID: number
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(deviceID.toString()!)}/ports`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, ports).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
 * Updates the notes of an existing NVR device via a PUT request.
 * 
 * @param deviceNotes - The NVR notes to be updated.
 * @param deviceID - The ID of the NVR device to update.
 * @returns An Observable emitting the updated NVR data (`CreateOrEditNVRDto`)
 */
  editNvrNotes(
    deviceNotes: { device: DeviceDto, deviceNotes: DeviceNoteDto[] }, deviceID: number
  ): Observable<CreateOrEditNVRDto> {
    let url = API_BASE_URL + `api/devices/nvr/${encodeURIComponent(deviceID.toString()!)}/notes`;
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, deviceNotes).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device tags in Hub
   * @param deviceId This is the deviceId parameter
   * @returns returns the device tags
   */
  getDeviceTags(deviceId: number): Observable<any> {
    let url = API_BASE_URL + 'api/devices/' + deviceId.toString() + '/tags';
    url = url.replace(/[?&]$/, '');

    return this.http.get<TimezoneList[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device tags');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for saving a Device Tag
   * @param input This is the input parameter
   * @returns returns the device
   */
  saveDeviceTags(input: DeviceTagParameter): Observable<any> {
    let url =
      API_BASE_URL + 'api/devices/' + input.deviceId.toString() + '/tags';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the post function for saving a Device NVR Detail Dates
   * @param input This is the input parameter
   * @returns returns success
   */
  saveNVRDetailDates(input: NVRDetailDatesParameter): Observable<any> {
    let url = API_BASE_URL + 'api/devices/nvr/detail-dates';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device alarm
   * @param id This is the id parameter
   * @returns returns the device alarm
   */
  getAlarmById(id: number): Observable<IDeviceAlarmModelData> {
    let url = API_BASE_URL + 'api/devices/alarm/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device alarm');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device alarm
   * @param parameter This is the parameter parameter
   * @returns returns the device alarm
   */
  getAlarm(parameter: URLSearchParams): Observable<any> {
    let url = API_BASE_URL + 'api/devices/alarm?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device alarm');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device alarm
   * @param input This is the input parameter
   * @returns returns success
   */
  createAlarm(input: CreateUpdateDeviceAlarm): Observable<any> {
    let url = API_BASE_URL + 'api/devices/alarm';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device alarm
   * @param input This is the input parameter
   * @returns returns success
   */
  updateAlarm(input: CreateUpdateDeviceAlarm): Observable<any> {
    let url = API_BASE_URL + 'api/devices/alarm';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device wireless card
   * @param id This is the parameter parameter
   * @returns returns the device wireless card
   */
  getWirelessCard(id: number): Observable<IDeviceWirelessCardModelData> {
    let url = API_BASE_URL + 'api/devices/wireless-card/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device wireless card');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device wireless card
   * @param input This is the input parameter
   * @returns returns success
   */
  createWirelessCard(input: CreateUpdateDeviceWirelessCard): Observable<any> {
    let url = API_BASE_URL + 'api/devices/wireless-card';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device wireless card
   * @param input This is the input parameter
   * @returns returns success
   */
  updateWirelessCard(input: CreateUpdateDeviceWirelessCard): Observable<any> {
    let url = API_BASE_URL + 'api/devices/wireless-card';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device input
   * @param parameter This is the parameter parameter
   * @returns returns the device input
   */
  getInput(parameter: URLSearchParams): Observable<any> {
    let url = API_BASE_URL + 'api/devices/input?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device input');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device input count
   * @param parameter This is the parameter parameter
   * @returns returns the device input count
   */
  getInputCount(parameter: URLSearchParams): Observable<any> {
    let url = API_BASE_URL + 'api/devices/input/count?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device input count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device input by id
   * @param id This is the id parameter
   * @returns returns the device input by id
   */
  getInputById(id: number): Observable<IDeviceInputModelData> {
    let url = API_BASE_URL + 'api/devices/input/' + id;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve device input count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating the device input
   * @param input This is the input parameter
   * @returns returns success
   */
  createInput(input: CreateUpdateDeviceInput): Observable<any> {
    let url = API_BASE_URL + 'api/devices/input';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the put function for updating the device input
   * @param input This is the input parameter
   * @returns returns success
   */
  updateInput(input: CreateUpdateDeviceInput): Observable<any> {
    let url = API_BASE_URL + 'api/devices/input';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the get function for get the device nvr names by site
   * @param siteId This is the siteId parameter
   * @returns returns the device nvr names by site
   */
  getNVRNames(siteId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/services/app/Device/GetNVRNames?siteId=' +
      siteId.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the nvr names by site');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device calendar nvrs
   * THIS ENDPOINT IS OBSOLETE, PLEASE USE getDevice(advancedFilters?: string | null | undefined)
   * and add the appropriate filters
   * @returns returns the device calendar nvrs
   */
  getCalendarNVRs(): Observable<any> {
    let url =
      API_BASE_URL + 'api/devices?deviceTypeId=1&statusId=1&sorting=Name%20ASC';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device calendar nvrs');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device calendar cameras
   * @param parentId This is the parentId parameter
   * @returns returns the device calendar cameras
   */
  getCalendarCameras(parentId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/devices? ' +
      parentId.toString() +
      '&deviceTypeId=2&statusId=1&sorting=Name%20ASC';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device calendar cameras');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device search list
   * @param siteId This is the siteId parameter
   * @returns returns the device search list
   */
  getDevicesSearchList(siteId: number | null | undefined): Observable<any> {
    let url =
      API_BASE_URL + 'api/services/app/Device/GetDevicesSearchList? ' + siteId;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device search list');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device camera installer
   * @returns returns the device camera installer
   */
  getCameraInstaller(): Observable<any> {
    let url = API_BASE_URL + 'api/services/app/Device/GetCameraInstaller';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device camera installer');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device multiple types
   * @param types This is the types parameter
   * @returns returns the device multiple types
   */
  getMultipleTypes(types: number[]): Observable<any> {
    let url = API_BASE_URL + 'api/services/app/Device/getMultipleTypes';
    url = url.replace(/[?&]$/, '');

    let params = new HttpParams();
    for (let t of types) {
      params = params.append('types', t.toString());
    }

    return this.http.get<any>(url, { params: params }).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device multiple types');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device module names
   * @param siteId This is the siteId parameter
   * @returns returns the device module names
   */
  getModuleNames(siteId: number): Observable<any> {
    let url = API_BASE_URL + 'api/devices';
    url = url.replace(/[?&]$/, '');

    let params = new HttpParams({
      fromObject: {
        siteId: siteId.toString(),
        deviceTypeId: DeviceType.Module.toString(),
      },
    });

    return this.http.get<any>(url, { params: params }).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device module names');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device talkdown names
   * @param nvrId This is the nvrId parameter
   * @returns returns the device talkdown names
   */
  getTalkdownNames(nvrId: number): Observable<DeviceOutput[]> {
    let url = API_BASE_URL + 'api/devices/output';
    url = url.replace(/[?&]$/, '');

    let params = new HttpParams({
      fromObject: {
        grandparentId: nvrId.toString(),
        outputTypeId: OutputType.Speaker.toString(),
      },
    });

    return this.http.get<any>(url, { params: params }).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device talkdown names');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the device credentials by device id
   * @param id This is the id parameter
   * @returns returns the device credentials by device id
   */
  getDeviceCredentialsByDeviceId(
    id: number
  ): Observable<DeviceCredentialDto[]> {
    let url =
      API_BASE_URL +
      'api/devices/' +
      encodeURIComponent('' + id) +
      '/credentials';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve the device credentials by device id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for creating the device credentials by device id
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  createEditDeviceCredentials(
    id: number | null | undefined,
    credentialType: CredentialType | null | undefined,
    input: Array<DeviceCredentialDto> | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/devices/' +
      encodeURIComponent('' + id) +
      '/credentials?credentialType=' +
      encodeURIComponent('' + credentialType);
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to create the device credentials by device id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for activating the device by device id
   * @param id This is the id parameter
   * @returns returns success
   */
  activateDevice(id: number | null | undefined): Observable<any> {
    let url =
      API_BASE_URL + 'api/devices/' + encodeURIComponent('' + id) + '/activate';
    url = url.replace(/[?&]$/, '');

    let options: any = {
      observe: 'response',
      responseType: 'blob',
    };

    return this.http.post<any>(url, options).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to activate the device by device id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for inactivating the device by device id
   * @param id This is the id parameter
   * @returns returns success
   */
  inactivateDevice(id: number | null | undefined): Observable<any> {
    let url =
      API_BASE_URL +
      'api/devices/' +
      encodeURIComponent('' + id) +
      '/inactivate';
    url = url.replace(/[?&]$/, '');

    let options: any = {
      observe: 'response',
      responseType: 'blob',
    };

    return this.http.post<any>(url, options).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to inactivate the device by device id');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for adding discovered the device by device discovered id
   * @param discoverId This is the discoverId parameter
   * @returns returns success
   */
  addDiscoveredCamera(discoverId: number | null | undefined): Observable<any> {
    let url =
      API_BASE_URL +
      'api/devices/discovered/camera/' +
      encodeURIComponent('' + discoverId) +
      '/add';
    url = url.replace(/[?&]$/, '');

    let options: any = {
      observe: 'response',
      responseType: 'blob',
    };

    return this.http.post<any>(url, options).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error(
            'Failed to add discovered the device by device discovered id'
          );
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for assigning discovered the device by device discovered id to a device by device id
   * @param discoverId This is the discoverId parameter
   * @param deviceId This is the discoverId parameter
   * @returns returns success
   */
  assignDiscoveredToExistingDevice(
    discoverId: number | null | undefined,
    deviceId: number | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/devices/discovered/camera/' +
      encodeURIComponent('' + discoverId) +
      '/add';
    url = url.replace(/[?&]$/, '');

    let options: any = {
      observe: 'response',
      responseType: 'blob',
    };

    return this.http.post<any>(url, options).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error(
            'Failed to assign discovered the device by device discovered id to a device by device id'
          );
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for unpausing cameras
   * @param input This is the input parameter
   * @returns returns success
   */
  unpauseCameras(
    input: PauseCameraAlarmDto[] | null | undefined
  ): Observable<any> {
    let url = API_BASE_URL + 'api/devices/camera/unpause-alarms';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to unpause cameras');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for unpausing cameras reason
   * @returns returns unpausing cameras reason
   */
  getUnpauseCameraReasons(): Observable<any> {
    let url = API_BASE_URL + 'api/devices/camera/unpauseReason';
    url = url.replace(/[?&]$/, '');

    return this.http.get<PausedDevicesDto>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve unpause reasons');
        }

        return response.result;
      })
    );
  }
  //#endregion DEVICES

  //#region REGIONS
  /**
   * This is the get function for getting all service regions
   * @returns returns the service regions
   */
  getServiceZones(): Observable<any> {
    let url = API_BASE_URL + 'api/regions/office-districts/service-zones';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve service regions');
        }

        return response.result;
      })
    );
  }
  //#endregion REGIONS

  //#region SITES

  /**
   * This is the get function for get the sites in Hub
   * @param filter This is the filter parameter
   * @param advancedFilters This is the advancedFilters parameter
   * @param sorting This is the sorting parameter
   * @param skipCount This is the skipCount parameter
   * @param maxResultCount This is the maxResultCount parameter
   * @returns returns the sites in Hub
   */
  getPaginatedSites(
    filter: string | null | undefined,
    advancedFilters: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<Site[]> {
    let url = API_BASE_URL + 'api/services/app/Site/GetAll?';
    if (filter != null) url += 'filter=' + encodeURIComponent(filter) + '&';

    if (advancedFilters != null)
      url += 'advancedFilters=' + encodeURIComponent(advancedFilters) + '&';

    if (sorting != null) url += 'sorting=' + encodeURIComponent(sorting) + '&';

    if (skipCount != null)
      url += 'skipCount=' + encodeURIComponent(skipCount) + '&';

    if (maxResultCount != null)
      url += 'maxResultCount=' + encodeURIComponent(maxResultCount);

    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result || !response.result.items) {
          throw new Error('Failed to retrieve sites');
        }

        return response.result.items.map((i: any) => i.site);
      })
    );
  }

  /**
   * This is the get function for getting all sites in Hub
   * @param advancedFilters This is the advancedFilters parameter
   * @returns returns the sites
   */
  getSites(advancedFilters?: string | null | undefined): Observable<Site[]> {
    let url = API_BASE_URL + 'api/sites';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve sites');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting site for editing
   * @param siteId This is the siteId parameter
   * @returns returns the sites for editing
   */
  getSiteForEdit(siteId: number): Observable<CreateEditSite> {
    let url =
      API_BASE_URL +
      'api/services/app/Site/GetSiteForEdit?id=' +
      encodeURIComponent('' + siteId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve site');
        }

        return response.result.site;
      })
    );
  }

  /**
   * This is the post function for creating or editing a site
   * @param site This is the site parameter
   * @returns returns success
   */
  editSite(site: CreateEditSite): Observable<void> {
    let url = API_BASE_URL + 'api/services/app/Site/CreateOrEdit';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, site);
  }

  /**
   * This is the delete function for deleting the site
   * @param id This is the id parameter
   * @returns returns success
   */
  delete(id: number | null | undefined): Observable<void> {
    let url = API_BASE_URL + 'api/services/app/Site/Delete?';
    if (id !== undefined) url += 'Id=' + encodeURIComponent('' + id) + '&';
    url = url.replace(/[?&]$/, '');

    return this.http.delete<any>(url);
  }

  /**
   * This is the get function for getting all sites in Hub
   * @param siteId This is the siteId parameter
   * @returns returns the sites
   */
  getSiteSearchList(siteId: number): Observable<any> {
    let url = API_BASE_URL + 'api/services/app/Site/GetSiteSearchList?';
    if (siteId !== undefined)
      url += 'siteId=' + encodeURIComponent('' + siteId) + '&';
    url = url.replace(/[?&]$/, '');

    return this.http.get(`${url}`).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve sites search list');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all sites in Hub
   * @returns returns the sites
   */
  getSiteList(): Observable<SiteDto[]> {
    let url_ = API_BASE_URL + 'api/services/app/Site/GetCMSSiteList';

    return this.http.get(`${url_}`).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve sites search list');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all sites for dashboard
   * @param customerId This is the customerId parameter
   * @returns returns the sites for dashboard
   */
  getSitesForDashboard(customerId: number): Observable<Site[]> {
    let url =
      API_BASE_URL +
      'api/sites/dashboard?customerId=' +
      encodeURIComponent('' + customerId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve sites for dashboard');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all sites for dashboard counts
   * @param advancedFilters This is the advancedFilters parameter
   * @returns returns the sites for dashboard counts
   */
  getSiteDashboardCounts(
    advancedFilters?: string | null | undefined
  ): Observable<SiteDashboardCounts> {
    let url = API_BASE_URL + 'api/sites/dashboard/count';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve site dashboard counts');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all sites details by site id
   * @param siteId This is the siteId parameter
   * @returns returns the sites details by site id
   */
  getSiteDetails(siteId: number): Observable<ISiteInformationModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/information';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteInformationModelData>(url);
  }

  /**
   * This is the get function for getting all sites alerts by site id and if it is read/unread
   * @param siteId This is the siteId parameter
   * @param unread This is the unread parameter
   * @returns returns the sites alerts
   */
  getSiteAlertsForUser(siteId: number, unread: boolean): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/alerts/';
    if (unread === true) {
      url += 'unread';
    } else {
      url += 'read';
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site alerts for user');
        }

        return unread === true ? response.result.unread : response.result.read;
      })
    );
  }

  /**
   * This is the put function for editing site info general
   * @param input This is the input parameter
   * @returns returns success
   */
  editSiteInfoGeneral(
    input: SiteInformation | null | undefined
  ): Observable<ISiteDetailsModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + input?.site.id) +
      '/general';
    url = url.replace(/[?&]$/, '');

    return this.http.put<ISiteDetailsModelData>(url, input);
  }

  /**
   * This is the get function for getting all sites monitoring-incidents-last-30-days
   * @param siteId This is the siteId parameter
   * @returns returns the sites monitoring-incidents-last-30-days
   */
  getMonitoringIncidents(siteId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/monitoring-incidents-last-30-days';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error(
            'Failed to retrieve site monitoring-incidents-last-30-days'
          );
        }
        return response.result;
      })
    );
  }

  /**
   * This is the put function for creating or editing a site info protocols
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteInfoProtocols(
    input: Array<SiteNote> | null | undefined,
    siteId: number | null | undefined
  ): Observable<SiteDto> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/protocols';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to create or edit site info protocols');
        }
        return response.result;
      })
    );
  }

  /**
   * This is the put function for editing a site info instructions
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteInfoInstructions(
    input: Array<SiteNote> | null | undefined,
    siteId: number | null | undefined
  ): Observable<SiteNote[]> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/instructions';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input);
  }

  /**
   * This is the put function for editing a site vendor-services-schedules
   * @param siteId This is the siteId parameter
   * @param schedules This is the schedules parameter
   * @returns returns success
   */
  updateSiteVendorServicesSchedules(
    siteId: number | null | undefined,
    schedules: Array<VendorServicesScheduleDto> | null | undefined
  ): Observable<VendorServicesScheduleDto[]> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/vendor-services-schedules';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, schedules);
  }

  /**
   * This is the put function for editing a site expected-site-activity
   * @param siteId This is the siteId parameter
   * @param selectedExpectedSiteActivityTypeId This is the selectedExpectedSiteActivityTypeId parameter
   * @returns returns success
   */
  updateExpectedSiteActivity(
    siteId: number | null | undefined,
    selectedExpectedSiteActivityTypeId: any | null | undefined
  ): any {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/expected-site-activity';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, selectedExpectedSiteActivityTypeId);
  }

  /**
   * This is the put function for editing a site worker-schedules
   * @param siteId This is the siteId parameter
   * @param schedules This is the schedules parameter
   * @returns returns success
   */
  updateSiteWorkerSchedules(
    siteId: number | null | undefined,
    schedules: Array<WorkerScheduleDto> | null | undefined
  ): Observable<WorkerScheduleDto[]> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/worker-schedules';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, schedules);
  }

  /**
   * This is the put function for editing a site additional-notes
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteInfoAdditionalNotes(
    input: Array<SiteNote> | null | undefined,
    siteId: number | null | undefined
  ): Observable<SiteDto> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/additional-notes';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input);
  }

  /**
   * This is the put function for editing a site service notes
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteInfoServiceNotes(
    siteId: number | null | undefined,
    input: Array<SiteNote> | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/service-notes';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input);
  }

  /**
   * This is the get function for getting a site IncidentsLast30Days
   * @param siteId This is the siteId parameter
   * @returns returns a site IncidentsLast30Days
   */
  GetIncidentsLast30Days(siteId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/SiteManagement/GetIncidentsLast30Days?siteId=' +
      encodeURIComponent('' + siteId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve IncidentsLast30Days');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site notes
   * @param id This is the id parameter
   * @returns returns a site notes
   */
  getSiteNotes(id: number | null | undefined): Observable<ISiteNoteResults> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + id) + '/notes';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteNoteResults>(url);
  }

  /**
   * This is the post function for creating a site notes
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  createSiteNote(
    id: number | null | undefined,
    input: SiteNote | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + id) + '/notes';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the post function for deleting a site notes
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  deleteSiteNote(
    id: number | null | undefined,
    input: SiteNote | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/notes/delete';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the get function for getting a site additional-info
   * @param siteId This is the siteId parameter
   * @returns returns a site additional-info
   */
  getAdditionalInfo(siteId: number): Observable<ISiteAdditionalInfoModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/additional-info';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteAdditionalInfoModelData>(url);
  }

  /**
   * This is the put function for editing a site additional info
   * @param additionalInfo This is the additionalInfo parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  updateAdditionalInfo(
    siteId: number,
    additionalInfo: SiteAdditionalInfo
  ): Observable<ISiteAdditionalInfoModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/additional-info';
    url = url.replace(/[?&]$/, '');

    return this.http.put<ISiteAdditionalInfoModelData>(url, additionalInfo);
  }

  /**
   * This is the put function for editing a site service details
   * @param serviceDetails This is the serviceDetails parameter
   * @param siteId This is the siteId parameter
   */
  updateSiteServiceDetails(
    siteId: number,
    serviceDetails: SiteServiceDetails
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/service';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, serviceDetails);
  }

  /**
   * This is the get function for getting a site service media
   * @param siteId This is the siteId parameter
   * @returns returns a site service media
   */
  getSiteServiceMedia(siteId: number): Observable<ServiceMedia> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/service-media';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve service media');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for editing a site service media
   * @param serviceMedia This is the serviceMedia parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteServiceMedia(
    siteId: number,
    serviceMedia: SiteServiceMedia
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/service-media';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, serviceMedia);
  }

  /**
   * This is the get function for getting a site customer notes by id
   * @param id This is the id parameter
   * @returns returns a site customer notes
   */
  getCustomerNotesBySiteId(
    id: number | null | undefined
  ): Observable<ICustomerNoteModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/customer-notes';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ICustomerNoteModelData>(url);
  }

  /**
   * This is the get function for getting a site customer notes by id
   * @param id This is the id parameter
   * @returns returns a site customer notes
   */
  getSiteAlerts(id: number | null | undefined): Observable<SiteAlertDto[]> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + id) + '/alerts';
    url = url.replace(/[?&]$/, '');

    return this.http.get<SiteAlertDto[]>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the post function for create a site alert
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  createSiteAlert(
    id: number | null | undefined,
    input: SiteAlertDto | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + id) + '/alerts';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the put function for editing a site alert
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  editSiteAlert(
    id: number | null | undefined,
    input: SiteAlertDto | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + id) + '/alerts';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the post function for deleting a site alert
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  deleteSiteAlerts(
    id: number | null | undefined,
    input: SiteAlertDto | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/alerts/delete';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to delete ');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for marking a site alert as read
   * @param siteId This is the siteId parameter
   * @param noteId This is the noteId parameter
   * @returns returns success
   */
  markSiteAlertAsRead(
    siteId: number | null | undefined,
    noteId: number | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/alerts/' +
      encodeURIComponent('' + noteId) +
      '/read';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, null).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the put function for marking a site alert as unread
   * @param siteId This is the siteId parameter
   * @param noteId This is the noteId parameter
   * @returns returns success
   */
  markSiteAlertAsUnread(
    siteId: number | null | undefined,
    noteId: number | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/alerts/' +
      encodeURIComponent('' + noteId) +
      '/unread';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, null).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the get function for getting a site customer notes by id
   * @param id This is the id parameter
   * @returns returns a site customer notes
   */
  generateEmailPreview(
    id: number | null | undefined,
    input: SiteEmergencyContactEmailDetailsDto | null | undefined
  ): Observable<SiteEmergencyEmailTemplateDto> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/emergency-contacts/preview-email';
    url = url.replace(/[?&]$/, '');

    return this.http.post<SiteEmergencyEmailTemplateDto>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to generate email preview');
        }
        return response.result;
      })
    );
  }

  /**
   * This is the post function for sending an email to emergency contacts
   * @param id This is the id parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  sendEmailToEmergencyContacts(
    id: number | null | undefined,
    input: SiteIncidentEmailDetailsDto | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/emergency-contacts/email';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to send email to emergency contacts ');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for editing Site stealth contact priority
   * @param siteId This is the siteId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  editSiteStealthContactPriority(
    siteId: number | null | undefined,
    input: Array<ContactPriority> | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/v2/sites/' +
      encodeURIComponent('' + siteId) +
      '/stealth-contacts/priority';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to edit site stealth contact priority ');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site maps
   * @param id This is the id parameter
   * @returns returns a site map
   */
  getSiteMaps(
    id: number | null | undefined
  ): Observable<ISiteMapsDtoModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/property-maps';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteMapsDtoModelData>(url);
  }

  /**
   * This is the post function for adding a site map
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  addSiteMaps(
    input: Array<SiteMapsDto> | null | undefined,
    siteId: number | null | undefined
  ): Observable<ISiteMapsDtoModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/property-maps';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input);
  }

  /**
   * This is the put function for marking a site alert as read
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteInfoMaps(
    input: Array<SiteMapsDto> | null | undefined,
    siteId: number | null | undefined
  ): Observable<SiteDto> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/property-maps';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the delete function for deleting site map(s)
   * @param siteId This is the siteId parameter
   * @param mapIds This is the mapIds parameter
   * @returns returns success
   */
  deleteSiteMaps(
    siteId: number | null | undefined,
    mapIds: number[] | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/property-maps';
    mapIds!.forEach((mapId, index) => {
      if (index == 0) {
        url += '?mapIds=' + encodeURIComponent('' + mapId);
      } else {
        url += '&mapIds=' + encodeURIComponent('' + mapId);
      }
    });
    url = url.replace(/[?&]$/, '');

    return this.http.delete<any>(url);
  }

  /**
   * This is the get function for getting a site attachments
   * @param id This is the id parameter
   * @returns returns a site attachments
   */
  getSiteAttachments(
    id: number | null | undefined
  ): Observable<ISiteAttachmentModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/attachments';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteAttachmentModelData>(url);
  }

  /**
   * This is the post function for adding site attachments
   * @param siteId This is the siteId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  addSiteAttachments(
    input: Array<SiteAttachmentsDto> | null | undefined,
    siteId: number | null | undefined
  ): Observable<ISiteAttachmentModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/attachments';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input);
  }

  /**
   * This is the delete function for deleting site attachments
   * @param siteId This is the siteId parameter
   * @param attachmentId This is the attachmentId parameter
   * @returns returns success
   */
  deleteSiteAttachments(
    siteId: number | null | undefined,
    attachmentId: number | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/attachments/' +
      encodeURIComponent('' + attachmentId);
    url = url.replace(/[?&]$/, '');

    return this.http.delete<any>(url);
  }

  /**
   * This is the get function for get the site monitoring incidents
   * @param siteId This is the siteId parameter
   * @param advancedFilters This is the advancedFilters parameter
   * @param sorting This is the sorting parameter
   * @param skipCount This is the skipCount parameter
   * @param maxResultCount This is the maxResultCount parameter
   * @returns returns the site monitoring incidents
   */
  getSiteMonitoringIncidents(
    siteId: number | null | undefined,
    advancedFilters: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/monitoring-incidents?';
    if (advancedFilters !== undefined && advancedFilters !== null) {
      url += advancedFilters + '&';
    }
    if (sorting !== undefined && sorting !== null) {
      url += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    }
    if (skipCount !== undefined && skipCount !== null) {
      url += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    }
    if (maxResultCount !== undefined && maxResultCount !== null) {
      url += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    }

    url = url.replace(/[?&]$/, '');

    return this.http.get<any[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site monitoring incidents');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site monitoring incident counts
   * @param siteId This is the siteId parameter
   * @param advancedFilters This is the advancedFilters parameter
   * @returns returns a site monitoring incident counts
   */
  getSiteMonitoringIncidentsCount(
    siteId: number | null | undefined,
    advancedFilters: string | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/monitoring-incidents/count?';
    if (advancedFilters !== undefined) url += advancedFilters + '&';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the get function for getting a site attachments
   * @param id This is the id parameter
   * @returns returns a site attachments
   */
  getSiteAddress(
    id: number | null | undefined
  ): Observable<ISiteAddressModelData> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + id) + '/address';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteAddressModelData>(url);
  }

  /**
   * This is the post function for editing Site Address Coordinates
   * @param siteId This is the siteId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  editSiteAddressCoordinates(
    input: SiteAddressCoordinateDto | null | undefined,
    siteId: number | null | undefined
  ): Observable<ISiteAddressModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/address/coordinates';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<ISiteAddressModelData>(url, input);
  }

  /**
   * This is the post function for editing Site stealth contact priority
   * @param siteId This is the siteId parameter
   * @param customerId This is the customerId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  assignSiteToNewCustomer(
    siteId: number | null | undefined,
    customerId: number | null | undefined,
    input: TransferInputDto | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/transfer/' +
      encodeURIComponent('' + customerId);
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return false;
      })
    );
  }

  /**
   * This is the get function for getting site authorities
   * @param id This is the id parameter
   * @returns returns a site authorities
   */
  getSiteAuthorities(
    id: number | null | undefined
  ): Observable<SiteAuthority[]> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/authorities';
    url = url.replace(/[?&]$/, '');

    return this.http.get<SiteAuthority[]>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the put function for editing a site authorities
   * @param input This is the input parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  editSiteInfoAuthorities(
    input: Array<SiteAuthority> | null | undefined,
    siteId: number | null | undefined
  ): Observable<SiteDto> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/authorities';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to create or edit site authorities');
        }
        return response.result;
      })
    );
  }

  /**
   * This is the post function for editing Site authority priority
   * @param siteId This is the siteId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  editSiteAuthorityPriority(
    siteId: number | null | undefined,
    input: Array<SiteAuthorityPriorityDto> | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/authorities/priority';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to edit Site authority priority');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for assigning existing authority to a site
   * @param authorityId This is the authorityId parameter
   * @param siteId This is the siteId parameter
   * @returns returns success
   */
  assignExistingAuthorityToSite(
    siteId: number,
    authorityId: number
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent(siteId) +
      '/authorities/' +
      encodeURIComponent(authorityId);
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, null);
  }

  /**
   * This is the post function for creating an assignment authority for a site
   * @param siteId This is the siteId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  createAuthorityAssignedToSite(
    siteId: number | null | undefined,
    input: Authority | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/authorities/priority';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to create an assignment authority for a site');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the delete function for deleting an assignment authority for a site
   * @param siteId This is the siteId parameter
   * @param authorityId This is the authorityId parameter
   * @returns returns success
   */
  deleteAuthorityFromSite(
    siteId: number | null | undefined,
    authorityId: number | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/authorities/' +
      encodeURIComponent('' + authorityId);
    url = url.replace(/[?&]$/, '');

    return this.http.delete<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to delete an assignment authority for a site');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for creating or editing a site authority instruction
   * @param siteId This is the siteId parameter
   * @param authorityId This is the authorityId parameter
   * @returns returns success
   */
  createOrEditAuthorityInstructions(
    siteId: number,
    authorityId: number,
    instructions: AuthorityNote[]
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent(siteId) +
      '/authorities/' +
      encodeURIComponent(authorityId) +
      '/instructions';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, instructions).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to create or edit a site authority instruction');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for editing a site authority phone priority
   * @param siteId This is the siteId parameter
   * @param authorityId This is the authorityId parameter
   * @param phoneNumberPriorities This is the phoneNumberPriorities parameter
   * @returns returns success
   */
  editAuthorityPhonePriority(
    siteId: number,
    authorityId: number,
    phoneNumberPriorities: SiteAuthorityPhonePriorityDto[]
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent(siteId) +
      '/authorities/' +
      encodeURIComponent(authorityId) +
      '/phone-numbers/priority';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, phoneNumberPriorities).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to edit a site authority phone priority');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site paused cameras
   * @param id This is the id parameter
   * @returns returns a site paused cameras
   */
  getSitePausedCameras(
    id: number | null | undefined
  ): Observable<PausedDevicesDto[]> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/paused-cameras';
    url = url.replace(/[?&]$/, '');

    return this.http.get<PausedDevicesDto>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve paused devices');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site onboarded cameras
   * @param id This is the id parameter
   * @returns returns a site onboarded cameras
   */
  getSiteOnboardedCameras(
    id: number | null | undefined
  ): Observable<OnboardDevicesNewDto[]> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/onboard-cameras';
    url = url.replace(/[?&]$/, '');

    return this.http.get<OnboardDevicesNewDto[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve onboarded cameras');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for onboarding cameras to Stealth Connect
   * @param id This is the id parameter
   * @returns returns a success
   */
  onboardCamerasForConnect(
    id: number | null | undefined,
    input: number[] | null | undefined
  ): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/onboard-cameras';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to onboard cameras for connect');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting a site devices tree view
   * @param siteId This is the siteId parameter
   * @returns returns a site devices tree view
   */
  getSiteDevicesTreeViewById(
    siteId: number | null | undefined
  ): Observable<IAttackMapTreeModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/devices/tree-model';
    url = url.replace(/[?&]$/, '');

    return this.http.get<IAttackMapTreeModelData>(url);
  }

  /**
   * This is the get function for get the timezones in Hub by site
   * @param siteId This is the siteId parameter
   * @returns returns the timezones in Hub by site
   */
  getSiteTimezoneById(siteId: number | null | undefined): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/timezones';
    url = url.replace(/[?&]$/, '');

    return this.http.get<TimezoneList[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Timezone List');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the site attack maps
   * @param siteId This is the siteId parameter
   * @returns returns the site attack maps
   */
  getSiteAttackMaps(
    id: number | null | undefined
  ): Observable<IAttackMapsDtoModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/attack-maps';
    url = url.replace(/[?&]$/, '');

    return this.http.get<IAttackMapsDtoModelData>(url);
  }

  /**
   * This is the post function for adding a site attack map
   * @param siteId This is the siteId parameter
   * @param input This is the input parameter
   * @returns returns success
   */
  addSiteAttackMaps(
    input: Array<AttackMapsDto> | null | undefined,
    siteId: number | null | undefined
  ): Observable<IAttackMapsDtoModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/attack-maps';
    url = url.replace(/[?&]$/, '');

    if (!input) {
      input = null;
    }

    return this.http.post<any>(url, input);
  }

  /**
   * This is the delete function for deleting a site attack map
   * @param siteId This is the siteId parameter
   * @param mapId This is the mapId parameter
   * @returns returns success
   */
  deleteSiteAttackMaps(
    siteId: number | null | undefined,
    mapId: number | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/attack-maps/' +
      encodeURIComponent('' + mapId);
    url = url.replace(/[?&]$/, '');

    return this.http.delete<any>(url);
  }

  /**
   * This is the get function for get the site alert requester suggestions
   * @param siteId This is the siteId parameter
   * @returns returns the site alert requester suggestions
   */
  getSiteAlertRequesterSuggestions(siteId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/alerts/requester/suggestions';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site alert requester suggestions');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for get the site monitoring hours
   * @param id This is the id parameter
   * @returns returns the site monitoring hours
   */
  getMonitoringHoursBySiteId(
    id: number | null | undefined
  ): Observable<ISiteMonitoringHoursModelData> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + id) +
      '/monitoring-hours';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ISiteMonitoringHoursModelData>(url);
  }

  /**
   * This is the get function for get the site protocols
   * @param parameter The SiteProtocolParameter containing filters
   * @returns returns the site protocols
   */
  getSiteProtocols(parameter: SiteProtocolParameter): Observable<SiteProtocolTableDto[]> {
    let url = API_BASE_URL + 'api/site-protocols/';
    const queryParams: string[] = [];

    // Add required siteId
    queryParams.push(`siteId=${parameter.siteId}`);

    // Add optional search parameter
    if (parameter.search) {
      queryParams.push(`search=${encodeURIComponent(parameter.search)}`);
    }

    // Add optional priorityTypeIds parameter (only if not selecting "All")
    if (parameter.priorityTypeIds && parameter.priorityTypeIds.length > 0) {
      parameter.priorityTypeIds.forEach(id => {
        queryParams.push(`priorityTypeIds=${id}`);
      });
    }

    // Add optional isActive parameter
    if (parameter.isActive !== undefined) {
      queryParams.push(`isActive=${parameter.isActive}`);
    }

    // Add optional sorting parameter
    if (parameter.sorting) {
      queryParams.push(`sorting=${encodeURIComponent(parameter.sorting)}`);
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    return this.http.get<{ result: SiteProtocolTableDto[] }>(url).pipe(
      map(response => response.result)
    );
  }

  /**
   * OBSOLETE: This is the get function for get the site protocol for edit
   * @param id This is the id parameter
   * @returns returns the site protocol
   */
  getSiteProtocolForEdit(
    id: number | null | undefined
  ): Observable<SiteProtocolDto> {
    let url =
      API_BASE_URL + 'api/site-protocols/' + encodeURIComponent('' + id);
    url = url.replace(/[?&]$/, '');

    return this.http.get<SiteProtocolDto>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site protocol for edit');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for creating a site protocol
   * @param input This is the input parameter
   * @returns returns success
   */
  createEditSiteProtocol(
    input: SiteProtocolDto | null | undefined
  ): Observable<ISiteProtocolModelData> {
    let url = API_BASE_URL + 'api/site-protocols';
    if (input?.id) {
      url += '/' + encodeURIComponent(input.id.toString());
      return this.http.put<ISiteProtocolModelData>(url, input);
    }

    url = url.replace(/[?&]$/, '');
    return this.http.post<ISiteProtocolModelData>(url, input);
  }

  /**
   * This is the delete function for deleting a site protocol
   * @param protocolId This is the protocolId parameter
   * @returns returns success
   */
  deleteSiteProtocol(
    protocolId: number | null | undefined
  ): Observable<boolean> {
    let url =
      API_BASE_URL +
      'api/site-protocols/' +
      encodeURIComponent('' + protocolId);
    url = url.replace(/[?&]$/, '');

    return this.http.delete<boolean>(url);
  }

  /**
   * This is the post function for deleting an escalation type from a protocol
   * @param payload This is the input parameter containing siteId and escalationTypeId
   * @returns returns success
   */
  deleteEscalationType(payload: any): Observable<boolean> {
    let url = API_BASE_URL + 'api/site-protocols/deleteEscalationType';
    url = url.replace(/[?&]$/, '');
    
    return this.http.post<boolean>(url, payload);
  }

  /**
   * This is the get function to retrieve the site tags
   * @param id This is the site id parameter
   * @returns returns the site protocol
   */
  getSiteTags(siteId: number): Observable<SiteTag[]> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + siteId) + '/tags';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site tags');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the put function for editing site tags
   * @param siteId This is the siteId parameter
   * @param tagIds This is the tagIds parameter
   * @returns returns success
   */
  editSiteTags(siteId: number, tagIds: number[]): Observable<void> {
    let url =
      API_BASE_URL + 'api/sites/' + encodeURIComponent('' + siteId) + '/tags';
    url = url.replace(/[?&]$/, '');

    return this.http.put<void>(url, tagIds);
  }

  /**
   * This is the get function for get the  site contacts
   * @param id This is the id parameter
   * @returns returns the  site contacts
   */
  getSiteContacts(id: number): Observable<SiteContact[]> {
    let url =
      API_BASE_URL + 'api/v2/sites/' + encodeURIComponent('' + id) + '/contact';
    url = url.replace(/[?&]$/, '');

    return this.http.get<SiteContact[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve  site contacts');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all site authorities in Hub
   * @returns returns the site authorities
   */
  getSiteAuthorityDetails(): Observable<any[]> {
    let url = API_BASE_URL + 'api/sites/allSiteAuthorities';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any[]>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the get function for getting a site service details
   * @param siteId This is the siteId parameter
   * @returns returns a site service details
   */
  getSiteServiceDetails(siteId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/service';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site service details');
        }

        return response.result;
      })
    );
  }
  //#endregion SITES

  /* Days of History */
  getDeviceStatistics(
    advancedFilters?: string | null | undefined
  ): Observable<DeviceStatistics> {
    let url = API_BASE_URL + 'api/DaysOfHistory/GetDeviceStats';
    if (advancedFilters != null) {
      url += '?' + advancedFilters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve device statistics');
        }

        return response.result;
      })
    );
  }

  //#region Incidents
  getIncidentTypeCount(
    filters?: string | null | undefined
  ): Observable<SiteIncidentTypeCount[]> {
    let url = API_BASE_URL + 'api/sites/dashboard/type-count';
    if (filters != null) {
      url += '?' + filters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<SiteIncidentTypeCount[]>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve incident count');
        }

        return response.result;
      })
    );
  }

  getIncidentVideoStatus(siteId: number): Observable<IncidentVideoStatus[]> {
    let url = API_BASE_URL + 'api/sites/incident-video-status?siteId=' + siteId;

    return this.http.get(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve sites customer service');
        }

        return response.result;
      })
    );
  }

  getDashboardIncidentVideoUrl(incidentId: number): Observable<any> {
    let url =
      API_BASE_URL +
      'api/sites/dashboard/incident-video-url?incidentId=' +
      incidentId;

    return this.http.get(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve dashboard incident video url');
        }

        return response.result;
      })
    );
  }

  /**
   * Retrieves an incident report by its ID.
   *
   * @param incidentId The ID of the incident to retrieve.
   * @param doRegenerateURLs A boolean indicating whether to regenerate URLs.
   * @returns An Observable containing the incident report.
   * @throws An error if the incident report retrieval fails.
   */
  getIncidentReport(incidentId: string, doRegenerateURLs: boolean): Observable<IncidentReportDto> {
    let url =
      API_BASE_URL +
      'api/sites/incident-report/' +
      incidentId +
      '?DoRegenerateURLs=' +
      doRegenerateURLs;

    return this.http.get(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve incident report');
        }

        return response.result;
      })
    );

  }

  /**
   * Searches for incidents at a specific site with optional advanced filters, sorting, and pagination.
   *
   * @param siteId The ID of the site to search incidents for.
   * @param advancedFilters Optional advanced filters for the search.
   * @param sorting Optional sorting criteria.
   * @param skipCount Optional number of records to skip.
   * @param maxResultCount Optional maximum number of records to return.
   * @returns An Observable containing the search results.
   * @throws An error if the site incidents retrieval fails.
   */
  getIncidentSiteSearch(siteId: number, filters: any[], sorting?: string, skipCount?: number, maxResultCount?: number): Observable<IncidentResult> {
    let url = API_BASE_URL + 'api/sites/' + siteId + '/incidents-search?';
    
    if (filters != null) {
      url += filters + '&';
    }

    if (sorting != null) {
      url += 'Sorting=' + encodeURIComponent(sorting) + '&';
    }
    if (skipCount != null) {
      url += 'SkipCount=' + skipCount + '&';
    }
    if (maxResultCount != null) {
      url += 'MaxResultCount=' + maxResultCount;
    }

    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site incidents');
        }

        return response.result;
      })
    );
  }
  //#endregion Incidents

  /* Zabbix */
  getActiveCountByRegion(): Observable<ZabbixCount> {
    let url = API_BASE_URL + 'api/Zabbix/GetActiveEntriesCountByRegion';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve active count by region');
        }

        return response.result;
      })
    );
  }

  getSiteCountByVertical(
    customerId?: number | null | undefined
  ): Observable<ZabbixSiteCount> {
    let url = API_BASE_URL + 'api/Zabbix/ZabbixGetSiteCountByVertical';
    if (customerId != null) {
      url += '?customerId=' + encodeURIComponent('' + customerId);
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve sites');
        }

        return response.result;
      })
    );
  }

  getNvrDetails(filters?: string | null | undefined): Observable<ZabbixNvr> {
    let url = API_BASE_URL + 'api/Zabbix/GetZabbixNVRDetails';
    if (filters != null) {
      url += '?' + filters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Zabbix NVR details');
        }

        return response.result;
      })
    );
  }

  getNvrDetailsForSites(
    siteIds?: number[] | null | undefined
  ): Observable<ZabbixNvr> {
    let url = API_BASE_URL + 'api/Zabbix/GetZabbixNVRDetailsBySiteIds';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, siteIds).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Zabbix NVR details for sites');
        }

        return response.result;
      })
    );
  }

  getCameraDetails(
    filters?: string | null | undefined
  ): Observable<ZabbixCamera> {
    let url = API_BASE_URL + 'api/Zabbix/GetZabbixCameraDetails';
    if (filters != null) {
      url += '?' + filters;
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Zabbix camera details');
        }

        return response.result;
      })
    );
  }

  getCameraDetailsForSites(
    siteIds?: number[] | null | undefined
  ): Observable<ZabbixCamera> {
    let url = API_BASE_URL + 'api/Zabbix/GetZabbixCameraDetailsBySiteIds';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, siteIds).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Zabbix camera details for sites');
        }

        return response.result;
      })
    );
  }

  getLastUpdateDetails(): Observable<ZabbixLastUpdateDetails> {
    let url = API_BASE_URL + 'api/Zabbix/GetZabbixLastUpdateDetails';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Zabbix last update details');
        }

        return response.result;
      })
    );
  }

  //begin:: Monitoring
  getTemplates(): Observable<Template[]> {
    let url = API_BASE_URL + 'api/v1/Configurations/Schedules/Templates';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Zabbix last update details');
        }

        return response.result;
      })
    );
  }

  createTemplate(input: Template | null | undefined): Observable<void> {
    let url = API_BASE_URL + 'api/v2/Configurations/Schedules/Templates/';
    url = url.replace(/[?&]$/, '');

    return this.http.post<boolean>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  editTemplate(input: Template | null | undefined): Observable<void> {
    let url = API_BASE_URL + 'api/v2/Configurations/Schedules/Templates/';
    url += input!.templateId;
    url = url.replace(/[?&]$/, '');

    return this.http.put<boolean>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  deleteTemplate(templateId: number): Observable<void> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/Templates/' +
      encodeURIComponent('' + templateId);
    url = url.replace(/[?&]$/, '');

    return this.http.delete<boolean>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  getDevicesAssignedToTemplates(
    templateId: number | null | undefined
  ): Observable<GetCustomerScheduleTemplatesForEditOutput> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/Templates/' +
      encodeURIComponent('' + templateId) +
      '/Devices';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Devices assigned to Templates');
        }

        return response.result;
      })
    );
  }

  getCustomerScheduleTemplates(
    customerId: number | null | undefined
  ): Observable<GetCustomerScheduleTemplatesForEditOutput> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/Templates/Customers/' +
      encodeURIComponent('' + customerId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Customer Schedule Templates');
        }

        return response.result;
      })
    );
  }

  getSiteScheduleTemplates(
    siteId: number | null | undefined
  ): Observable<GetCustomerScheduleTemplatesForEditOutput> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/Templates/Sites/' +
      encodeURIComponent('' + siteId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Site Schedule Templates');
        }

        return response.result;
      })
    );
  }

  getNVRScheduleTemplates(
    nvrId: number | null | undefined
  ): Observable<GetCustomerScheduleTemplatesForEditOutput> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/Templates/NVRs/' +
      encodeURIComponent('' + nvrId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve NVR Schedule Templates');
        }

        return response.result;
      })
    );
  }

  getCameraScheduleTemplates(
    cameraId: number | null | undefined
  ): Observable<GetCustomerScheduleTemplatesForEditOutput> {
    let url =
      API_BASE_URL +
      'api/v1/Configurations/Schedules/Templates/Cameras/' +
      encodeURIComponent('' + cameraId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve Camera Schedule Templates');
        }

        return response.result;
      })
    );
  }

  deleteGroupScheduleOverride(
    input: AssignOverrideDto | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/v2/Configurations/Schedules/GroupScheduleException/Delete';
    url = url.replace(/[?&]$/, '');

    return this.http.post<boolean>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  createGroupScheduleOverride(
    input: AssignOverrideDto | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL + 'api/v3/Configurations/Schedules/GroupScheduleException';
    url = url.replace(/[?&]$/, '');

    return this.http.post<boolean>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }
  //end:: Monitoring

  //#region GUARD TOUR
  /**
   * This is the get function to retrieve the guard tours
   * @param advancedFilters This is the advancedFilters parameter
   * @param sorting This is the sorting parameter
   * @param skipCount This is the skipCount parameter
   * @param maxResultCount This is the maxResultCount parameter
   * @returns returns the guard tours
   */
  getGuardTours(
    advancedFilters: string | null | undefined,
    sorting?: string | null | undefined,
    skipCount?: number | null | undefined,
    maxResultCount?: number | null | undefined
  ): Observable<GuardTour[]> {
    let url = API_BASE_URL + 'api/guard-tours?';
    if (advancedFilters !== undefined && advancedFilters !== null)
      url += advancedFilters + '&';
    if (sorting !== undefined && sorting !== null)
      url += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount !== undefined && skipCount !== null)
      url += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined && maxResultCount !== null)
      url += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve guard tours');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function to retrieve the guard tour counts by nvr
   * @returns returns a dictionary with nvr device id and corresponding guard tour counts
   */
  getGuardTourCountsByNVR(deviceIds: Array<number>): Observable<any> {
    let url = API_BASE_URL + 'api/guard-tours/nvr/counts';
    url = url.replace(/[?&]$/, '');

    return this.http.post<void>(url, { deviceIds: deviceIds }).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve guard tour counts by nvr.');
        }
        return response.result;
      })
    );
  }

  /**
   * This is the get function to retrieve the guard tour timezone list
   * @returns returns the guard tours timezone list
   */
  getGuardTourTimezoneLookup(): Observable<TimezoneList[]> {
    let url = API_BASE_URL + 'api/guard-tours/timezones';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve guard tour timezones');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function to retrieve the guard tour to be edited
   * @param id This is the guard tour id of the guard tour to be edited
   * @returns returns the guard tour to be edited
   */
  getGuardTourForEdit(id: number): Observable<CreateEditGuardTour> {
    let url = API_BASE_URL + 'api/guard-tours/' + encodeURIComponent('' + id);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw new Error('Failed to retrieve guard tour for edit');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the function to create or edit a guard tour
   * @param input This is the guard tour to be created or edited
   * @returns returns void
   */
  createOrEditGuardTour(
    input: CreateEditGuardTour | null | undefined
  ): Observable<void> {
    let url = API_BASE_URL + 'api/guard-tours/';
    if (input?.id) {
      url += input.id;
      url = url.replace(/[?&]$/, '');
      return this.http.put<void>(url, input);
    }

    url = url.replace(/[?&]$/, '');
    return this.http.post<void>(url, input);
  }
  //#endregion GUARD TOUR

  //#region SEARCH STEALTH

  /**
   * This is the post function for searching in Hub via search type
   * @param input This is the search filter
   * @param searchType This is the search type
   * @returns returns based on the search type
   */
  search(
    input: SearchFilter | null | undefined,
    searchType: string | null | undefined
  ): Observable<any> {
    let url = API_BASE_URL + 'api/' + searchType + '/search';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return undefined;
      })
    );
  }

  /**
   * This is the post function for search count in Hub via search type
   * @param input This is the search filter
   * @param searchType This is the search type
   * @returns returns the search count number
   */
  searchCount(
    input: SearchFilter | null | undefined,
    searchType: string | null | undefined
  ): Observable<number> {
    let url = API_BASE_URL + 'api/' + searchType + '/search/count';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return 0;
      })
    );
  }

  /**
   * This is the v1 post function for searching in Hub via search type
   * @param input This is the search filter
   * @returns returns based on the search type
   */
  dynamicSearchV1(
    input: DynamicSearchFilter | undefined
  ): Observable<DynamicSearchResult> {
    let url = API_BASE_URL + 'api/v3/search';
    url = url.replace(/[?&]$/, '');

    return this.http.post<DynamicSearchResult>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return {
          items: [],
          totalCount: 0,
        };
      })
    );
  }

  /**
   * This is the v2 post function for searching in Hub via search type
   * @param input This is the search filter
   * @returns returns based on the search type
   */
  dynamicSearchV2(
    input: DynamicSearchFilter | undefined
  ): Observable<DynamicSearchResult> {
    let url = API_BASE_URL + 'api/v4/search';
    url = url.replace(/[?&]$/, '');

    return this.http.post<DynamicSearchResult>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return {
          items: [],
          totalCount: 0,
        };
      })
    );
  }

  dynamicExportSearchV2(input: DynamicSearchFilter, template: any, columnHeaderMap: any, format: string, additionalColumns?: string[]): Observable<Blob> {
    let url = API_BASE_URL + 'api/v4/search/Export?format=' + encodeURIComponent(format);
    url = url.replace(/[?&]$/, '');

    const requestBody = {
      parameter: input,
      templates: template,
      columnHeaderMap: columnHeaderMap,
      additionalColumns: additionalColumns
    };

    return this.http.post(url, requestBody, {
      responseType: 'blob',
    });
  }

  bulkUpdateSites(payload: BulkSiteUpdateRequest): Observable<BulkUpdateResult> {
    const url = API_BASE_URL + 'api/sites/bulk-update';
    return this.http.put<BulkUpdateApiResponse>(url, payload)
      .pipe(map(response => response.result));
  }
  //#endregion SEARCH STEALTH

  //begin:: Site Details
  /**
   * This is the get function for getting all site service details in Hub
   * @returns returns the site service details
   */
  getAllSiteServiceDetails(): Observable<any[]> {
    let url = API_BASE_URL + 'api/sites/allSiteServiceDetails';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any[]>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  getUserNotes(
    advancedFilters: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<any> {
    let url = API_BASE_URL + 'api/user-notes?';
    if (advancedFilters !== undefined && advancedFilters !== null)
      url += advancedFilters + '&';
    if (sorting !== undefined && sorting !== null)
      url += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount !== undefined && skipCount !== null)
      url += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined && maxResultCount !== null)
      url += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve user notes');
        }

        return response.result;
      })
    );
  }

  /* END: Site Details */

  assignDeviceScheduleTemplate(
    templateId: number | null | undefined,
    input: Array<DeviceTemplate> | null | undefined
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/v2/Configurations/Schedules/Templates/' +
      encodeURIComponent('' + templateId) +
      '/Devices';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, input).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to onboard cameras for connect');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting all the camera links
   * @returns returns list of all the camlinks
   */
  getCamlinks(parameter: URLSearchParams): Observable<Camlinks[]> {
    let url = API_BASE_URL + 'api/Camlinks?' + parameter.toString();
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve all camlinks');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for getting the max result count for camlinks
   * @returns returns the number of camlinks
   */
  getCamlinksCount(parameter: CamlinksParameter): Observable<number> {
    let url = API_BASE_URL + 'api/Camlinks/count?';

    if (parameter.nvrName?.trim().length !== 0) {
      url += 'NVRName=' + encodeURIComponent('' + parameter.nvrName) + '&';
    }

    if (parameter.isActive !== undefined) {
      url += 'IsActive=' + encodeURIComponent('' + parameter.isActive) + '&';
    }

    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve camlinks count');
        }

        return response.result;
      })
    );
  }

  //#region USER VIEWS

  /**
   * This is the get function for getting the reports view
   * @returns returns the reports view
   */
  getUserColumnViews(): Observable<ReportsView[]> {
    let url = API_BASE_URL + 'api/user-view/getReportsView';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ReportsView[]>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the post function for saving reports view in Hub
   * @param viewName This is the view name parameter
   * @param columns This is the columns parameter
   * @param selectListId This is the selectListId parameter
   * @returns returns the search override report
   */
  saveReportView(
    viewName: string,
    columns: string,
    selectListId: number
  ): Observable<boolean> {
    let url = API_BASE_URL + 'api/user-view/saveReportsView';
    url = url.replace(/[?&]$/, '');

    let input = {
      id: undefined,
      viewName: viewName,
      columns: columns,
      selectListId: selectListId,
      userId: undefined,
    };

    return this.http.post<boolean>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }

  /**
   * This is the post function for updating reports view in Hub
   * @param id This is the view name parameter
   * @param viewName This is the view name parameter
   * @param columns This is the columns parameter
   * @param selectListId This is the selectListId parameter
   * @returns returns the search override report
   */
  updateReportView(
    id: number,
    viewName: string,
    columns: string,
    selectListId: number
  ): Observable<boolean> {
    let url = API_BASE_URL + 'api/user-view/updateReportsView';
    url = url.replace(/[?&]$/, '');

    let input = {
      id: id,
      viewName: viewName,
      columns: columns,
      selectListId: selectListId,
      userId: undefined,
    };

    return this.http.post<boolean>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return [];
      })
    );
  }
  //#endregion USER VIEWS

  //#region APPLICATION CATALOG
  /**
   * This is the get function for retrieving the App Catalog download link
   * @applicationId This is the id parameter
   * @os This is the isLinux boolean parameter
   * @returns returns download link string
   */
  getDownloadLink(
    applicationId: number,
    isProductionReady: boolean,
    isLinux: boolean = false,
    isArm64: boolean = false
  ): Observable<string> {
    let url =
      API_BASE_URL +
      'api/AppCatalog/GetDownloadLink?appId=' +
      applicationId +
      '&isProductionReady=' +
      isProductionReady;
    if (isLinux) {
      url += '&isLinux=true';
    }
    if (isArm64) {
      url += '&isArm64=true';
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get application download link');
        }

        return response.result.item1.url;
      })
    );
  }

  /**
   * This is the get function for retrieving the applications
   * @deviceTypeId This is the device type id parameter
   * @returns returns applications
   */
  getApplications(deviceTypeId: number, environment?: string): Observable<Application[]> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GetApplications?deviceTypes=' +
      encodeURIComponent('' + deviceTypeId);
    if (environment)
      url += '&environment=' + environment;

    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get applications');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving application builds
   * @applicationId This is the id parameter
   * @isProduction This is the is production boolean parameter
   * @environment This is the environment name parameter
   * @returns returns application builds
   */
  getApplicationBuilds(
    applicationId: number,
    isProduction: boolean,
    environment: string
  ): Observable<ApplicationBuild[]> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GetApplicationBuilds?appId=' +
      encodeURIComponent('' + applicationId);
    if (isProduction)
      url += '&isProduction=' + isProduction + '&environment=' + environment;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get application builds');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving application builds
   * @applicationId This is the id parameter
   * @isProduction This is the is production boolean parameter
   * @environment This is the environment name parameter
   * @returns returns application builds
   */
  getApplicationBuildsV2(
    applicationId: number,
    environment: string
  ): Observable<ApplicationBuild[]> {
    let url =
      API_BASE_URL +
      'api/v4/AppCatalog/GetApplicationBuilds?id=' +
      encodeURIComponent('' + applicationId);
    url += '&environment=' + environment;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get application builds');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving the latest application build
   * @applicationId This is the id parameter
   * @isProduction This is the is production boolean parameter
   * @environment This is the environment name parameter
   * @returns returns the latest application build
   */
  getLatestApplicationBuild(
    applicationId: number,
    isProduction: boolean,
    environment: string
  ): Observable<ApplicationBuild> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GetLatestApplicationBuild?appId=' +
      encodeURIComponent('' + applicationId);
    if (isProduction)
      url += '&isProduction=' + isProduction + '&environment=' + environment;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get application builds');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving the latest application build
   * @applicationId This is the id parameter
   * @isProduction This is the is production boolean parameter
   * @environment This is the environment name parameter
   * @returns returns the latest application build
   */
  getLatestApplicationBuildV2(
    applicationId: number,
    environment: string
  ): Observable<ApplicationBuild> {
    let url =
      API_BASE_URL +
      'api/v4/AppCatalog/GetLatestApplicationBuild?id=' +
      encodeURIComponent('' + applicationId);

    url += '&environment=' + environment;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get application builds');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving device app details
   * @applicationId This is the id parameter
   * @deviceTypeId This is the device type id parameter
   * @returns returns device app details
   */
  getDeviceAppDetails(
    applicationId: number,
    hasLatestVersion: boolean,
    notLatestVersion: boolean,
    isNotInstalled: boolean,
    deviceTypeId: number,
    isProduction: boolean,
    environment: string,
    version: number | null | undefined,
    filter: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | null | undefined,
    skipCount: number | null | undefined
  ): Observable<IDeviceCurrentVersionModelData> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GetLatestApplicationVersionForDevices?' +
      'ApplicationId=' +
      encodeURIComponent('' + applicationId) +
      '&' +
      'HasLatestVersion=' +
      encodeURIComponent('' + hasLatestVersion) +
      '&' +
      'DoesNotHaveLatestVersion=' +
      encodeURIComponent('' + notLatestVersion) +
      '&' +
      'IsNotInstalled=' +
      encodeURIComponent('' + isNotInstalled) +
      '&' +
      'DeviceTypeId=' +
      encodeURIComponent('' + deviceTypeId) +
      '&';
    if (isProduction)
      url +=
        'isProduction=' + isProduction + '&environment=' + environment + '&';
    if (version !== undefined && version !== null)
      url += 'BuildVersionId=' + encodeURIComponent('' + version) + '&';
    if (filter !== undefined && filter !== null)
      url += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null)
      url += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount !== undefined && skipCount !== null)
      url += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined && maxResultCount !== null)
      url += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get device app details');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving device app details
   * @applicationId This is the id parameter
   * @deviceTypeId This is the device type id parameter
   * @returns returns device app details
   */
  getDeviceAppDetailsV2(
    applicationId: number,
    environment: string,
    deviceTypeId: number
  ): Observable<IDeviceCurrentVersionModelDataV2> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GetLatestApplicationVersionForDevicesV2?' +
      'deviceTypeId=' +
      encodeURIComponent('' + deviceTypeId) +
      '&' +
      'env=' +
      encodeURIComponent('' + environment) +
      '&' +
      'applicationId=' +
      encodeURIComponent('' + applicationId);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to get device app details');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for the devices viable for bulk updates
   * @deviceTypeId This is the device type id parameter
   * @returns returns list of devices with application builds
   */
  getApplicationsBulkUpdateList(
    deviceTypeId: number
  ): Observable<PagedResultDtoOfBulkInstallVersionDto> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GETApplicationsBulkUpdateList?';
    url += 'DeviceTypeId=' + encodeURIComponent('' + deviceTypeId) + '&';
    url = this.setEnvironmentUrl(url, true);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get devices for bulk update.');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the get function for the devices viable for bulk updates
   * @deviceTypeId This is the device type id parameter
   * @returns returns list of devices with application builds
   */
  getApplicationsBulkUpdateListV2(
    deviceTypeId: number,
    environment: string
  ): Observable<PagedResultDtoOfBulkInstallVersionDto> {
    let url =
      API_BASE_URL +
      'api/v6/AppCatalog/GetApplicationsBulkUpdateList?' +
      'deviceTypeId=' +
      encodeURIComponent('' + deviceTypeId) +
      '&' +
      'env=' +
      encodeURIComponent('' + environment);
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get devices for bulk update.');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for the devices viable for bulk updates
   */
  getApplicationsBulkUpdateListV4(parameters: ParameterBulkUpdateDto): Observable<BulkUpdateDto> {
    let url = API_BASE_URL + 'api/v6/AppCatalog/BulkUpdateList';
    url = url.replace(/[?&]$/, '');
    return this.http.post<any>(url, parameters).pipe(
      map((response: any) => {
        if (!response) {
          throw new Error('Failed to get devices for bulk update.');
        }
        return response.result;
      })
    );
  }


  /**
   * This is the post function to bulk update all applications on device to latest
   * @deviceList List of devices to be updated
   * @returns boolean success
   */
  bulkUpdateDevices(deviceList: BulkInstallVersionDto[]): Observable<any> {
    let url = API_BASE_URL + 'api/services/app/AppCatalog/BulkUpdateDevices';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, deviceList).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get devices for bulk update.');
        }

        return response.success;
      })
    );
  }

  /**
   * This is the post function to bulk offboard devices
   * @deviceList List of devices to be offboarded
   * @returns boolean success
   */
  bulkUninstallDevices(deviceList: BulkInstallVersionDto[]): Observable<any> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/BulkUninstallApplicationOnDevices';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, deviceList).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get devices for bulk update.');
        }

        return response.success;
      })
    );
  }

  private setEnvironmentUrl(
    url: string,
    isRequiredParam: boolean = false
  ): string {
    if (environment.production) {
      url += `isProduction=true&environment=${environment.name}`;
    } else if (isRequiredParam) {
      url += `isProduction=false`; // Append if isProduction is a required parameter
    }

    return url;
  }

  /**
   * This is the get function for retrieving the count of devices with the latest application build
   * @deviceTypeId This is the device type id parameter
   * @applicationId This is the application id parameter
   * @isProduction This is the is production boolean parameter
   * @environment This is the environment name parameter
   * @returns returns the latest application build
   */
  getDeviceOnLatestBuildCount(
    deviceTypeId: number,
    applicationId: number,
    isProduction: boolean,
    environment: string
  ): Observable<number> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/GetDeviceOnLatestBuildCount?deviceTypeId=' +
      encodeURIComponent('' + deviceTypeId) +
      '&appId=' +
      encodeURIComponent('' + applicationId);
    if (isProduction)
      url += '&isProduction=' + isProduction + '&environment=' + environment;
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get device count');
        }

        return response.result;
      })
    );
  }

  /**
   * This is the post function for installing an application to specified devices
   * @applicationId This is the application id parameter
   * @buildId This is the build if parameter
   * @devices This is the list of devices parameter
   * @returns returns the application installed
   */
  installApplication(
    applicationId: number,
    buildId: number,
    devices: DeviceCurrentVersion[]
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/InstallApplicationOnDevices?appId=' +
      encodeURIComponent('' + applicationId) +
      '&buildId=' +
      encodeURIComponent('' + buildId);
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, devices);
  }

  /**
   * This is the post function for installing an application to specified devices
   * @applicationId This is the application id parameter
   * @buildId This is the build if parameter
   * @devices This is the list of devices parameter
   * @returns returns the application installed
   */
  modifyApplications(devices: DeviceAutoRequest[]): Observable<void> {
    let url = API_BASE_URL + 'api/v4/AppCatalog/ListOfDeviceAutoRequest';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, devices);
  }

  uninstallApplication(
    applicationId: number,
    devices: DeviceToUninstall[]
  ): Observable<void> {
    let url =
      API_BASE_URL +
      'api/services/app/AppCatalog/UninstallApplicationOnDevices?appId=' +
      encodeURIComponent('' + applicationId);
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, devices);
  }

  //#endregion APPLICATION CATALOG

  //#region Site Stealth Contacts

  /**
   * This is the get function for getting the total count of stealth contacts based on the filter
   * @param advancedFilters This is the parameter for filtering stealth contacts
   * @param sorting This is the sorting parameter
   * @param skipCount This is the skipCount parameter
   * @param maxResultCount This is the maxResultCount parameter
   * @returns returns stealth contacts
   */
  getStealthContacts(
    advancedFilters: string | null | undefined = undefined,
    sorting?: string | null | undefined,
    skipCount?: number | null | undefined,
    maxResultCount?: number | null | undefined
  ): Observable<StealthContact[]> {
    let url = API_BASE_URL + 'api/v2/stealth-contacts?';
    if (advancedFilters !== undefined) {
      url += advancedFilters + '&';
    }
    if (sorting !== undefined) {
      url += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    }
    if (skipCount !== undefined) {
      url += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    }
    if (maxResultCount !== undefined) {
      url += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    }
    url = url.replace(/[?&]$/, '');

    return this.http.get<StealthContact[]>(url).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return undefined;
      })
    );
  }
  /**
   * This is the get function for retrieving the Stealth Contacts assigned to site
   * @siteId This is the site id parameter
   * @returns returns list of Stealth Contacts assigned to the site
   */
  getSiteStealthContacts(siteId: number): Observable<StealthContact[]> {
    let url = API_BASE_URL + 'api/v2/sites/' + siteId + '/stealth-contact';
    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error(
            'Failed to get stealth contacts for site id: ' + siteId + '.'
          );
        }
        return response.result;
      })
    );
  }

  /**
   * This is the get function for retrieving data for a Stealth Contacts assigned to site
   * @contactId This is the stealth contact id parameter
   * @returns returns the details of the Stealth Contact assigned to the site
   */
  getSiteStealthContact(contactId: number): Observable<StealthContact> {
    let url = API_BASE_URL + 'api/v2/stealth-contacts/' + contactId;
    url = url.replace(/[?&]$/, '');

    return this.http.get<StealthContact>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get stealth contact id: ' + contactId + '.');
        }
        return response.result;
      })
    );
  }

  /**
 * This is the get function for retrieving the Stealth contact summary list for a site
 * @siteId Site ID parameter to filter Stealth contacts by
 * @contactTypeId Contact type ID to filter the Stealth contacts by
 * @contactTypeIds List of contact type IDs to filter the Stealth contacts by
 * @returns returns a summary list of Stealth contacts assigned to the site
 */
  getSiteStealthContactsSummary(
    siteId: number,
    contactTypeId?: number,
    contactTypeIds?: number[]
  ): Observable<StealthContact[]> {
    let url = API_BASE_URL + 'api/v2/sites/' + siteId + '/stealth-contact-summary?';

    if (contactTypeId) {
      url += "ContactTypeId=" + encodeURIComponent("" + contactTypeId) + "&";
    }

    if (contactTypeIds && contactTypeIds.length > 0) {
      url += contactTypeIds.map(id => `ContactTypeIds=${id}`).join("&");
    }

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error(
            'Failed to get stealth contacts for site id: ' + siteId + '.'
          );
        }
        return response.result;
      })
    );
  }

  /**
   * This is the put function that updates the priority of the Stealth Contacts for the Site
   * @priority This is the priority parameter
   * @returns boolean for success
   */
  savePriority(
    siteId: number,
    siteContactPriority: StealthContactPriority[]
  ): Observable<boolean> {
    let url =
      API_BASE_URL + 'api/v2/sites/' + siteId + '/stealth-contacts/priority';
    url = url.replace(/[?&]$/, '');

    return this.http.put<any>(url, siteContactPriority).pipe(
      map((response: any) => {
        if (response?.result) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  /**
   * This is the post function that updates the assigned sites for a Stealth Contact
   * @contactId This is the contact Id parameter
   * @siteIDs This is the site Ids parameter. A list of sites to which the contact is to be assigned to.
   * @returns boolean for success
   */
  stealthContactAssignSites(
    contactId: number,
    siteIDs: number[]
  ): Observable<boolean> {
    let url =
      API_BASE_URL + 'api/v2/stealth-contacts/' + contactId + '/sites/assign';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, siteIDs).pipe(
      map((response: any) => {
        if (response?.result) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  /**
   * This is the function for creating a new stealth contact for the site
   * @param input This is the stealth contact parameter
   * @returns returns success
   */
  stealthContactCreate(input: StealthContact): Observable<boolean> {
    let url = API_BASE_URL + 'api/v2/stealth-contacts';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (!response && response.status != 200) {
          throw Error('Failed to create stealth contact.');
        }
        return true;
      })
    );
  }
  //#endregion Site Stealth Contacts

  //#region Salesforce Service Tickets
  /**
   * This is the function for getting service tickets for salesforce
   * @param siteId This is the site id parameter which is required
   */
  getSalesforceServiceTickets(
    siteId: number,
    status?: string,
    role?: string
  ): Observable<ServiceTicketQueryDto[]> {
    let url = API_BASE_URL + 'api/ServiceTicket/Client';
    url = url.replace(/[?&]$/, '');

    let params = new HttpParams()
      .set('siteId', siteId.toString());

    if (status) {
      params = params.set('status', status);
    }

    if (role) {
      params = params.set('role', role);
    }

    return this.http.get<ServiceTicketQueryDto[]>(url, { params }).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get stealth contact id: ' + siteId + '.');
        }
        return response.result;
      })
    );
  }

  createServiceTicket(
    input: ServiceTicketRequestDto
  ): Observable<ServiceTicketResponseDto> {
    let url = API_BASE_URL + 'api/ServiceTicket';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return undefined;
      })
    );
  }

  createBulkServiceTicket(
    input: Array<ServiceTicketRequestDto>
  ): Observable<Array<ServiceTicketBulkResponse>> {
    let url = API_BASE_URL + 'api/ServiceTicket/Bulk';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return undefined;
      })
    );
  }

  /**
   * This is the function for gets all problem code types for salesforce
   */
  getProblemCodes(): Observable<ProblemCode[]> {
    let url = API_BASE_URL + 'api/ServiceTicket/ProblemCodes';
    url = url.replace(/[?&]$/, '');

    return this.http.get<ProblemCode[]>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get problem codes.');
        }
        return response.result;
      })
    );
  }

  /**
   * This is the function for gets the image preview given the url
   * @param url Url of the image file
   */
  loadPreviewImage(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob',
    });
  }

  /**
   * This is the function for creation of MC Changes ticket
   * @param input This is the MC Changes request parameter which is required
   */
  createMCChangesTicket(input: any): Observable<any> {
    let url = API_BASE_URL + 'api/ServiceTicket/McChanges';
    url = url.replace(/[?&]$/, '');

    return this.http.post<any>(url, input).pipe(
      map((response: any) => {
        if (response?.result) {
          return response.result;
        }
        return response;
      })
    );
  }
  //#endregion Salesforce Service Tickets

  //#region Camera Audit
  /**
   * This is the function for requesting an audit report.
   * @param auditReport This is the request body for the audit report.
   * @returns returns an observable of HTTP response containing the audit report result.
   */
  requestAuditReport(auditReport: AuditRequestDto): Observable<any> {
    let url_ = API_BASE_URL + 'api/camera-audit/GenerateReport';
    return this.http.post<any>(url_, auditReport).pipe(
      map((response: any) => {
        return response.result;
      })
    );
  }

  /**
   * This is the function for getting the latest audit report.
   * @returns returns an observable of HTTP response containing the latest audit report.
   */
  getLatestAuditReport(): Observable<AuditResponseDto> {
    let url_ = API_BASE_URL + 'api/camera-audit/GetLatestReport';
    return this.http.get(url_).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get Audit Report: ');
        }
        return response.result;
      })
    );
  }

  RetrieveLatestAuditReports(params: AuditReportRequestDto): Observable<AuditReportResponseDto> {
    let url_ = API_BASE_URL + 'api/camera-audit/RetrieveLatestAuditReports';
    return this.http.post(url_, params).pipe(
      map((response: any) => {
        if (!response.result) {
          throw Error('Failed to get Audit Report: ');
        }
        return response.result;
      })
    )
  }

  

  /**
   * This is the function for getting the weekly generated audit report.
   * @returns returns an observable of HTTP response containing the latest audit report.
   */
  getLatestWeeklyAuditReport(tenantId: number): Observable<AuditResponseDto> {
    let url_ = API_BASE_URL + `api/camera-audit/weekly-report?TenantId=${tenantId}`;
    return this.http.get(url_).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get Audit Report: ');
        }
        return response.result;
      })
    );
  }


  getSiteForCameraAuditsWithFilters(
    filters: GetAuditScriptSiteParameter
  ): Observable<GetAuditScriptSite[]> {
    const queryString = filters.toQueryString();
    let url = `${API_BASE_URL}api/sites/audit-script`;

    if (queryString) url = `${url}?${queryString}`;

    url = url.replace(/[?&]$/, '');

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response?.result) {
          throw Error('Failed to retrieve site details');
        }

        return response.result;
      })
    );
  }

  getSiteCameraScoreDetails(siteId: number): Observable<SiteCameraScoreResponse> {
    let url =
      API_BASE_URL +
      'api/sites/' +
      encodeURIComponent('' + siteId) +
      '/camera-score';
    url = url.replace(/[?&]$/, '');

    return this.http.get<SiteCameraScoreResponse>(url);
  }
  //#endregion

  //#region NFZ
  getAllNfzSchedules(
    siteId: number,
    params: NFZParameter
  ): Observable<NoFlyZoneScheduleGroupDto[]> {
    let url_ = API_BASE_URL + 'api/sites/no-fly-zone/groups';
    let httpParams = new HttpParams();

    Object.keys(params).forEach((key) => {
      const value = (params as any)[key];
      if (value !== null && value !== undefined) {

        if (key.toLowerCase() === 'cameraids' || key.toLowerCase() === 'nvrids') {
          value.forEach((id: any) => {
            httpParams = httpParams.append(key, id.toString())
          })
          return
        }

        httpParams = httpParams.set(key, value.toString());
      }
    });

    return this.http
      .get<NoFlyZoneScheduleGroupDto[]>(url_, { params: httpParams })
      .pipe(
        map((response: any) => {
          if (!response) {
            throw Error('Failed to get No Fly Zone schedules.');
          }
          return response.result;
        })
      );
  }

  createNfzSchedule(nfzData: NoFlyZoneScheduleGroupDto[]) {
    const url = API_BASE_URL + 'api/sites/no-fly-zone/groups';

    return this.http.post<any>(url, nfzData).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to get No Fly Zone schedules.');
        }
        return response.result;
      })
    );
  }

  updateNfzSchedule(nfzData: NoFlyZoneScheduleGroupDto) {
    const url = API_BASE_URL + 'api/sites/no-fly-zone/group';

    return this.http.put<any>(url, nfzData).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to update No Fly Zone schedules.');
        }
        return response.result
      })
    )
  }
  //#endregion NFZ

  //#region Log Report Notification
  /**
   * This is the get function for checking if a site is SVIR whitelisted
   * @param siteId This is the siteId parameter
   * @returns returns a boolean indicating if the site is SVIR whitelisted
   */
  public isSVIRWhitelisted(siteId: number): Observable<boolean> {
    const url = API_BASE_URL + 'api/sites/' + siteId + '/is-svir-whitelisted';

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to check if site is SVIR whitelisted.');
        }
        return response.result;
      })
    );
  }
  //#endregion Log Report Notification

  //#region Partners

  public getPartnerBySiteId(siteId: number): Observable<Partner | null> {
    const url = API_BASE_URL + 'api/sites/' + siteId + '/partner';

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to check for the site\'s partner');
        }
        return response.result;
      })
    );
  }
  //#enderegion Partners

  //#region Worker Handling
  public isWorkerHandlingEnabled(siteId: number): Observable<boolean> {
    const url = API_BASE_URL + 'api/sites/' + siteId + '/is-workerhandling-enabled';

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to determine if worker handling is enabled on the site.');
        }
        return response.result;
      })
    );
  }

  public createOrUpdateWorkerHandling(
    siteId: number,
    userId: number,
    isEnabled: boolean
  ): Observable<boolean> {

  const input = { siteId, userId, isEnabled };
  const url = API_BASE_URL + 'api/v7/sites/createupdate-workerhandling';

  return this.http.post<boolean>(url, input).pipe(
      map((response: any) => response.result ?? false)
    );
  }
  //#endregion Worker Handling

  //#region Requeue
  public isAllowRequeue(siteId: number): Observable<boolean> {
    const url = API_BASE_URL + 'api/sites/' + siteId + '/is-requeue-enabled';

    return this.http.get<any>(url).pipe(
      map((response: any) => {
        if (!response) {
          throw Error('Failed to determine if requeue is enabled on the site.');
        }
        return response.result;
      })
    );
  }

  public createOrUpdateRequeue(
    siteId: number,
    userId: number,
    isEnabled: boolean
  ): Observable<boolean> {

  const input = { siteId, userId, isEnabled };
  const url = API_BASE_URL + 'api/v7/sites/createupdate-requeue';

  return this.http.post<boolean>(url, input).pipe(
      map((response: any) => response.result ?? false)
    );
  }
  //#endregion Requeue

  //region Bulk update Camera
  deactivateCameraBulk(nvrId: number | number[]): Observable<any> {
    const url = `${API_BASE_URL}api/devices/nvr/cameras/deactivate`;
    const body = Array.isArray(nvrId) ? nvrId : [nvrId];
    return this.http.put<number>(url, body).pipe(
      catchError(() => {
        throw new Error('Failed to deactivate cameras');
      })
    );
  }

  getCamerasCredentialExisting(deviceIds: number[]): Observable<CamerasCredential[]> {
    const url = `${API_BASE_URL}api/devices/GetCredentialsByDevicesAsync`;
    return this.http.post<any>(url, deviceIds).pipe(
      map(response => {
        if (!response.success) {
          throw new Error(response.error?.message ?? 'Failed to fetch camera credentials');
        }
        return (response.result as CamerasCredential[]) ?? [];
      }),
      catchError(error => {
        console.error('Error fetching credentials:', error);
        return throwError(() => error);
      })
    );
  }

  private readonly BULK_ENDPOINTS = {
    credentials: { path: 'BulkCameraCredential', context: 'camera credentials' },
    generalInfo: { path: 'BulkCameraGeneralInfo', context: 'camera general informations' },
    detail: { path: 'BulkCameraDetailsInfo', context: 'camera details' }
  } as const;

  private bulkUpdate<T>(endpoint: string, request: T, errorContext: string): Observable<number> {
    const url = `${API_BASE_URL}api/devices/${endpoint}`;
    
    return this.http.put<any>(url, request).pipe(
      map(response => response.result ?? 0),
      catchError(error => {
        console.error(`Error updating ${errorContext}:`, error);
        const errorMessage = error.error || `Failed to update ${errorContext}`;
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  bulkUpdateCamerasCredentials(request: BulkCamerasCredentialRequest): Observable<number> {
    const { path, context } = this.BULK_ENDPOINTS.credentials;
    return this.bulkUpdate(path, request, context);
  }

  bulkUpdateCamerasGeneralInfo(request: BulkCamerasGeneralInfoRequest): Observable<number> {
    const { path, context } = this.BULK_ENDPOINTS.generalInfo;
    return this.bulkUpdate(path, request, context);
  }

  bulkUpdateCamerasDetail(request: BulkCamerasDetailRequest): Observable<number> {
    const { path, context } = this.BULK_ENDPOINTS.detail;
    return this.bulkUpdate(path, request, context);
  }
  //#endregion Bulk update Camera

  bulkUpdateCallProtocolSteps(request: BulkSiteProtocolUpdateDto): Observable<BulkProtocolStepContactUpdateResultDto> {
    const url = `${API_BASE_URL}api/site-protocols/protocol-step-contacts/bulk`;

    return this.http.put<any>(url, request).pipe(
      map((response: any) => response?.result ?? emptyBulkProtocolStepContactUpdateResultDto),
      catchError((error) => {
        console.error('Error bulk updating call protocol steps:', error);
        const errorMessage = error?.error || 'Failed to bulk update call protocol steps';
        return throwError(() => new Error(errorMessage));
      })
    );
  }
}
